import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Moment from "moment";
import Collapsible from "react-collapsible";
import { useDropzone } from "react-dropzone";
import { Tab, Tabs } from "react-bootstrap";
import download from "downloadjs";
import jsPDF from "jspdf";
import ReactToPrint from "react-to-print";

import PaymentModal from "../modals/PaymentModal";
import NoteModal from "../modals/NoteModal";
import SalePartsSection from "./SalePartsSection";
import SaleEditPaymentModal from "./SaleEditPaymentModal";
import SaleProductSpecificationsSection from "./SaleProductSpecificationsSection";
import SaleSummaryHeader from "./SaleSummaryHeader";
import { SalesContext } from "../../context/salesContext";
import { CustomersContext } from "../../context/customersContext";
import { Badge, Button, ConfirmDialog, SaleRecordTable, Spinner } from "../ui";
import { API_URL, REMOTE_FILES_BASE_URL } from "../../constants/config";
import "./Sale.css";
import "../forms/Form.css";
import InsertDesigns from "../../data/insertDesigns.json";
import statusList from "../../data/statusList.json";
import sills from "../../data/sills.json";
import lockTypes from "../../data/lockTypes.json";
import hingeColours from "../../data/hingeColours.json";
import DoorStyles from "../../data/doorStyles.json";

function paintLineQtyPositive(item) {
    const q = item.quantity;
    if (q === "" || q == null) return false;
    const n = parseInt(String(q), 10);
    return !Number.isNaN(n) && n > 0;
}

/* react-to-print iframe: force sheet + chrome white (avoids gray body behind content). */
const PAINT_PRINT_PAGE_STYLE = `
  @media print {
    html, body {
      background: #ffffff !important;
      margin: 0 !important;
      padding: 0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

export class ComponentToPrint extends React.PureComponent {
    render() {
        const {
            updatedSale,
            selectedSale,
            paintEditForm,
            handleUpdateList,
            setUpdatedSale,
            setRecentActivities,
            handleUpdateCheckbox,
            removePaintItem,
            updating,
            paintItem,
            handleUpdatePaint,
            addPaintItem,
            addingPaintItemError,
            createPaintList,
        } = this.props;
        const hasPaintItems =
            updatedSale.paintList?.items && updatedSale.paintList.items.length > 0;
        const paintListItems = updatedSale.paintList?.items ?? [];
        const paintRowEntries = paintListItems
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => paintEditForm || paintLineQtyPositive(item));
        const showPaintItemsTable = paintRowEntries.length > 0;
        const paintItemsForQtyTotal = paintEditForm
            ? paintListItems
            : paintListItems.filter(paintLineQtyPositive);
        const pickedUpDateRaw = updatedSale.paintList?.pickedUpDate;
        const hasPickedUpDateValue =
            pickedUpDateRaw !== "" && pickedUpDateRaw != null && Moment(pickedUpDateRaw).isValid();
        const showPickedUpRow = hasPaintItems && (paintEditForm || hasPickedUpDateValue);
        const notesRaw = updatedSale.paintList?.specialNotes ?? "";
        const showNotesBlock = paintEditForm || String(notesRaw).trim().length > 0;
        const shipToField = (
            <>
                <label className="Sale-paint-label" htmlFor="shipTo">
                    Ship to
                </label>
                {paintEditForm ? (
                    <select
                        id="shipTo"
                        className="Sale-paintform-input Sale-paint-select"
                        value={updatedSale.paintList?.shipTo ?? ""}
                        onChange={(event) =>
                            handleUpdateList(
                                setUpdatedSale,
                                "shipTo",
                                event.target.value,
                                "paintList",
                            )
                        }
                        onBlur={setRecentActivities}
                        disabled={!paintEditForm}
                    >
                        <option value=""></option>
                        <option value="Roy (Quality Cote)">Roy (Quality Cote)</option>
                        <option value="Gary (UV Coating)">Gary (UV Coating)</option>
                        <option value="Ebi (Vynal Colour Land Inc)">
                            Ebi (Vynal Colour Land Inc)
                        </option>
                        <option value="Mike (Monarch)">Mike (Monarch)</option>
                        <option value="Andreas (Artisan)">Andreas (Artisan)</option>
                        <option value="Kevin's Coating Inc">Kevin's Coating Inc</option>
                    </select>
                ) : (
                    <span className="Sale-paint-readonly">
                        {updatedSale.paintList?.shipTo || "—"}
                    </span>
                )}
            </>
        );
        return (
            <div className="Sale-paintlist-printable">
                <div className="Sale-paint-meta">
                    <div className="Sale-paint-company-card Sale-paint-print-only">
                        <p className="Sale-paint-company-name">Summit Doors</p>
                        <dl className="Sale-paint-company-lines">
                            <div className="Sale-paint-dl-row">
                                <dt>Address</dt>
                                <dd>737 Fenmar Drive, North York, ON</dd>
                            </div>
                            <div className="Sale-paint-dl-row">
                                <dt>Fax</dt>
                                <dd>416-391-6041</dd>
                            </div>
                            <div className="Sale-paint-dl-row">
                                <dt>Office</dt>
                                <dd>416-742-9188</dd>
                            </div>
                            <div className="Sale-paint-dl-row">
                                <dt>Mobile</dt>
                                <dd>647-296-2825</dd>
                            </div>
                        </dl>
                    </div>

                    <div className="Sale-paint-order-card">
                        {hasPaintItems ? (
                            <div className="Sale-paint-row Sale-paint-row--half">
                                <div className="Sale-paint-field Sale-paint-field--half">
                                    <label className="Sale-paint-label" htmlFor="createdDate">
                                        Date Created
                                    </label>
                                    {paintEditForm ? (
                                        <input
                                            id="createdDate"
                                            className="Sale-paintform-input Sale-paint-input-date"
                                            type="date"
                                            value={Moment(updatedSale.paintList.createdDate)
                                                .utc()
                                                .format("YYYY-MM-DD")}
                                            onChange={(event) =>
                                                handleUpdateList(
                                                    setUpdatedSale,
                                                    "createdDate",
                                                    event.target.value,
                                                    "paintListDate",
                                                )
                                            }
                                            onBlur={setRecentActivities}
                                            disabled={!paintEditForm}
                                        />
                                    ) : (
                                        <span className="Sale-paint-readonly">
                                            {Moment(updatedSale.paintList.createdDate).format("LL")}
                                        </span>
                                    )}
                                </div>
                                <div className="Sale-paint-field Sale-paint-field--half Sale-paint-field--ship">
                                    {shipToField}
                                </div>
                            </div>
                        ) : (
                            <div className="Sale-paint-field Sale-paint-field--ship">
                                {shipToField}
                            </div>
                        )}

                        {showPickedUpRow && (
                            <div className="Sale-paint-row Sale-paint-row--picked">
                                <div className="Sale-paint-picked-stack">
                                    {paintEditForm && (
                                        <div className="Sale-paint-field">
                                            <div className="Sale-paint-field--inline">
                                                <label
                                                    className="Sale-paint-label"
                                                    htmlFor="pickedUp"
                                                >
                                                    Picked up
                                                </label>
                                                <input
                                                    id="pickedUp"
                                                    name="pickedUp"
                                                    className="Sale-paint-checkbox"
                                                    type="checkbox"
                                                    checked={Boolean(
                                                        updatedSale.paintList?.pickedUp,
                                                    )}
                                                    onChange={handleUpdateCheckbox}
                                                    onBlur={setRecentActivities}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {(paintEditForm || hasPickedUpDateValue) && (
                                        <div className="Sale-paint-field">
                                            <label
                                                className="Sale-paint-label"
                                                htmlFor="pickedUpDate"
                                            >
                                                Picked up date
                                            </label>
                                            {paintEditForm ? (
                                                <input
                                                    id="pickedUpDate"
                                                    name="pickedUpDate"
                                                    className="Sale-paintform-input Sale-paint-input-date"
                                                    type="date"
                                                    value={Moment(
                                                        updatedSale.paintList.pickedUpDate,
                                                    )
                                                        .utc()
                                                        .format("YYYY-MM-DD")}
                                                    onChange={(event) =>
                                                        handleUpdateList(
                                                            setUpdatedSale,
                                                            "pickedUp",
                                                            event.target.value,
                                                            "paintListDate",
                                                        )
                                                    }
                                                    onBlur={setRecentActivities}
                                                />
                                            ) : (
                                                <span className="Sale-paint-readonly">
                                                    {Moment(
                                                        updatedSale.paintList.pickedUpDate,
                                                    ).format("LL")}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="Sale-paintform-items">
                    {showPaintItemsTable && (
                        <div className="Sale-paint-items-heading">
                            <span className="Sale-paint-items-title">Items</span>
                            <span className="Sale-paint-items-count">
                                {paintItemsForQtyTotal.reduce((accum, item) => {
                                    if (item.quantity !== "") {
                                        return accum + parseInt(item.quantity, 10);
                                    }
                                    return accum + 0;
                                }, 0)}{" "}
                                total qty
                            </span>
                        </div>
                    )}
                    {showPaintItemsTable && (
                        <div className="Sale-paint-table-wrap">
                            <table className="Sale-table-list Sale-parts-table Sale-paint-items-table">
                                <thead>
                                    <tr>
                                        <th>Qty</th>
                                        <th>Item</th>
                                        <th>Side</th>
                                        <th>Colour</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paintRowEntries.map(({ item, index }) => {
                                        return (
                                            <tr key={`paint-row-${index}`}>
                                                <td style={{ width: "8%" }}>
                                                    <input
                                                        className="Sale-paintform-input"
                                                        type="number"
                                                        value={item.quantity}
                                                        onChange={(event) =>
                                                            handleUpdateList(
                                                                setUpdatedSale,
                                                                "quantity",
                                                                event.target.value,
                                                                "paintListItem",
                                                                index,
                                                            )
                                                        }
                                                        onBlur={setRecentActivities}
                                                        disabled={!paintEditForm}
                                                    />
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <input
                                                        className="Sale-paintform-input"
                                                        type="text"
                                                        value={item.item}
                                                        onChange={(event) =>
                                                            handleUpdateList(
                                                                setUpdatedSale,
                                                                "item",
                                                                event.target.value,
                                                                "paintListItem",
                                                                index,
                                                            )
                                                        }
                                                        onBlur={setRecentActivities}
                                                        disabled={!paintEditForm}
                                                    />
                                                </td>
                                                <td style={{ width: "15%" }}>
                                                    {paintEditForm ? (
                                                        <select
                                                            className="Sale-paintform-input"
                                                            value={item.side}
                                                            onChange={(event) =>
                                                                handleUpdateList(
                                                                    setUpdatedSale,
                                                                    "side",
                                                                    event.target.value,
                                                                    "paintListItem",
                                                                    index,
                                                                )
                                                            }
                                                            onBlur={setRecentActivities}
                                                            disabled={!paintEditForm}
                                                        >
                                                            <option value=""></option>
                                                            <option value="Out">Out</option>
                                                            <option value="In/Out">In/Out</option>
                                                            <option value="In">In</option>
                                                        </select>
                                                    ) : (
                                                        <input
                                                            className="Sale-paintform-input"
                                                            type="text"
                                                            value={item.side}
                                                            onChange={(event) =>
                                                                handleUpdateList(
                                                                    setUpdatedSale,
                                                                    "item",
                                                                    event.target.value,
                                                                    "paintListItem",
                                                                    index,
                                                                )
                                                            }
                                                            onBlur={setRecentActivities}
                                                            disabled={!paintEditForm}
                                                        />
                                                    )}
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <input
                                                        className="Sale-paintform-input"
                                                        type="text"
                                                        value={item.colour}
                                                        onChange={(event) =>
                                                            handleUpdateList(
                                                                setUpdatedSale,
                                                                "colour",
                                                                event.target.value,
                                                                "paintListItem",
                                                                index,
                                                            )
                                                        }
                                                        onBlur={setRecentActivities}
                                                        disabled={!paintEditForm}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            {paintEditForm && (
                                <div className="Sale-paint-remove-wrap">
                                    <Button
                                        type="button"
                                        variant="danger"
                                        size="sm"
                                        onClick={removePaintItem}
                                    >
                                        {updating ? (
                                            <Spinner size="sm" label="Removing…" />
                                        ) : (
                                            "Remove paint list"
                                        )}
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {showNotesBlock && (
                    <div className="Sale-paintform-items Sale-paint-notes-block">
                        <p className="Sale-paint-notes-label">Notes</p>
                        {paintEditForm ? (
                            <textarea
                                id="specialNotes"
                                name="specialNotes"
                                className="Sale-paint-notes"
                                type="text"
                                value={updatedSale.paintList?.specialNotes ?? ""}
                                onChange={(event) =>
                                    handleUpdateList(
                                        setUpdatedSale,
                                        "specialNotes",
                                        event.target.value,
                                        "paintList",
                                    )
                                }
                                onBlur={setRecentActivities}
                            />
                        ) : (
                            <p className="Sale-paint-notes-readonly">{String(notesRaw).trim()}</p>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const ScrollableTabs = ({ children }) => {
    const wrapRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const syncArrows = useCallback(() => {
        const nav = wrapRef.current?.querySelector(".nav-tabs");
        if (!nav) return;
        setCanScrollLeft(nav.scrollLeft > 0);
        setCanScrollRight(nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 1);
    }, []);

    useEffect(() => {
        const nav = wrapRef.current?.querySelector(".nav-tabs");
        if (!nav) return;
        syncArrows();
        nav.addEventListener("scroll", syncArrows);
        const ro = new ResizeObserver(syncArrows);
        ro.observe(nav);
        return () => {
            nav.removeEventListener("scroll", syncArrows);
            ro.disconnect();
        };
    }, [syncArrows]);

    const scroll = (dir) => {
        const nav = wrapRef.current?.querySelector(".nav-tabs");
        if (nav) nav.scrollBy({ left: dir * 120, behavior: "smooth" });
    };

    return (
        <div ref={wrapRef} className="Sale-tabs-wrap">
            {canScrollLeft && (
                <button
                    type="button"
                    className="Sale-tabs-arrow Sale-tabs-arrow--left"
                    onClick={() => scroll(-1)}
                    aria-label="Scroll tabs left"
                >
                    <i className="fas fa-chevron-left" aria-hidden="true" />
                </button>
            )}
            {children}
            {canScrollRight && (
                <button
                    type="button"
                    className="Sale-tabs-arrow Sale-tabs-arrow--right"
                    onClick={() => scroll(1)}
                    aria-label="Scroll tabs right"
                >
                    <i className="fas fa-chevron-right" aria-hidden="true" />
                </button>
            )}
        </div>
    );
};

const Sale = (props) => {
    const { selectedSale, setSelectedSale, openSaleModal } = props;
    const { customers } = useContext(CustomersContext);
    const { updating, action } = useContext(SalesContext);
    const customerList = customers || [];
    const [editForm, setEditForm] = useState(false);
    const [paymentModalShow, setPaymentModalShow] = useState(false);
    const [editPaymentModalOpen, setEditPaymentModalOpen] = useState(false);
    const [selectedPaymentStorageIndex, setSelectedPaymentStorageIndex] = useState(null);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [flattenPrevArray] = useState([]);
    const [flattenUpdatedArray] = useState([]);
    const [paintSectionEditMode, setPaintSectionEditMode] = useState(false);
    const [specSectionEditMode, setSpecSectionEditMode] = useState(false);
    const [attachmentDeleteTarget, setAttachmentDeleteTarget] = useState(null);
    const [activeSpecPanel, setActiveSpecPanel] = useState("doorSystem");

    const [updatedSale, setUpdatedSale] = useState({
        orderDate: selectedSale.orderDate || "",
        customerId: selectedSale.customerId || "",
        contractor: selectedSale.contractor || "",
        po: selectedSale.po || "",
        product: selectedSale.product || "",
        productSpecification: selectedSale.productSpecification || {},
        paymentMethod: selectedSale.paymentMethod || "",
        cost: selectedSale.cost || "",
        labourCost: selectedSale.labourCost || "",
        salesPrice: selectedSale.salesPrice || "",
        workOrder: selectedSale.workOrder || {},
        expectedCompletionDate: selectedSale.expectedCompletionDate || "",
        completionDate: selectedSale.completionDate || "",
        notes: selectedSale.notes || [],
        payments: selectedSale.payments || [],
        recentActivities: selectedSale.recentActivities || [],
        files: selectedSale.files || [],
        paintList: selectedSale.paintList || {},
        partsList: selectedSale.partsList || [],
    });

    useEffect(() => {
        setPaintSectionEditMode(false);
    }, [selectedSale._id]);

    const [files, setFiles] = useState([]);
    const [uploadMessage, setUploadMessage] = useState("");
    const [uploading, setUploading] = useState(false);
    const [queueingFiles, setQueueingFiles] = useState(false);
    // Upload files library
    const onDrop = useCallback((acceptedFiles) => {
        if (!acceptedFiles || acceptedFiles.length === 0) return;
        setQueueingFiles(true);
        setFiles((prev) => [...prev, acceptedFiles]);
        setTimeout(() => setQueueingFiles(false), 120);

        updatedSale.recentActivities.push(
            `${Moment().format("LLL")}: ${
                Moment().format("YYYY-MM-DD") + "_" + acceptedFiles[0].name
            } was added.`,
        );
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    const addFile = async (event) => {
        event.preventDefault();
        setUploadMessage("");

        try {
            if (files.length <= 0) {
                setUploadMessage("Failed");
                setTimeout(() => {
                    setUploadMessage("");
                }, 2500);
            } else {
                setUploading(true);

                const formData = new FormData();

                files.map((file) => {
                    updatedSale.files.push(Moment().format("YYYY-MM-DD") + "_" + file[0].name);
                    formData.append(`name`, Moment().format("YYYY-MM-DD") + "_" + file[0].name);
                    formData.append(`file`, file[0]);
                });

                await action.upload(formData);
                await action.updateSale(selectedSale._id, updatedSale);
                setFiles([]);
                setUploading(false);
                setUploadMessage("Successful");
                setTimeout(() => {
                    setUploadMessage("");
                }, 2500);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const getFile = async (file) => {
        const blob = await action.getFiles(file, selectedSale._id);
        if (!blob) return undefined;

        const url = URL.createObjectURL(blob);

        const reader = new FileReader();
        reader.onload = (r) => {
            console.log(r.target.result);
        };

        return reader.readAsDataURL(blob);
    };

    const mimeFromAttachmentFilename = (filename) => {
        const ext = String(filename).split(".").pop()?.toLowerCase();
        const map = {
            pdf: "application/pdf",
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            webp: "image/webp",
            svg: "image/svg+xml",
            txt: "text/plain",
            csv: "text/csv",
            html: "text/html",
            htm: "text/html",
        };
        return map[ext] || "";
    };

    const isLocalApiUrl = (() => {
        try {
            const u = new URL(API_URL);
            return u.hostname === "localhost" || u.hostname === "127.0.0.1";
        } catch (_e) {
            return false;
        }
    })();

    const buildRemoteAttachmentUrl = (file) =>
        `${REMOTE_FILES_BASE_URL}/${encodeURIComponent(String(file))}`;

    const downloadAttachment = async (file) => {
        try {
            const blob = await action.getFiles(file, selectedSale._id);
            if (!blob) {
                if (isLocalApiUrl) {
                    window.open(buildRemoteAttachmentUrl(file), "_blank", "noopener,noreferrer");
                    return;
                }
                console.error("Download failed: no file data returned.");
                return;
            }
            download(blob, file);
        } catch (err) {
            if (isLocalApiUrl) {
                window.open(buildRemoteAttachmentUrl(file), "_blank", "noopener,noreferrer");
                return;
            }
            console.error("Download failed:", err);
        }
    };

    const openAttachmentInBrowser = async (file) => {
        try {
            const blob = await action.getFiles(file, selectedSale._id);
            if (!blob) {
                if (isLocalApiUrl) {
                    window.open(buildRemoteAttachmentUrl(file), "_blank", "noopener,noreferrer");
                    return;
                }
                console.error("Open failed: no file data returned.");
                return;
            }

            const inferred = mimeFromAttachmentFilename(file);
            const blobToOpen =
                blob.type && blob.type !== "application/octet-stream"
                    ? blob
                    : inferred
                      ? new Blob([await blob.arrayBuffer()], { type: inferred })
                      : blob;

            const url = URL.createObjectURL(blobToOpen);
            const newTab = window.open(url, "_blank", "noopener,noreferrer");

            if (!newTab) {
                URL.revokeObjectURL(url);
                window.alert(
                    "Your browser blocked the new tab. Allow pop-ups for this site, or use Download below.",
                );
                return;
            }

            const revoke = () => URL.revokeObjectURL(url);
            setTimeout(revoke, 120_000);
        } catch (err) {
            if (isLocalApiUrl) {
                window.open(buildRemoteAttachmentUrl(file), "_blank", "noopener,noreferrer");
                return;
            }
            console.error("Open in browser failed:", err);
        }
    };

    const removeFile = async (file, selectedIndex) => {
        const updatedFiles = updatedSale.files
            .slice(0)
            .reverse()
            .filter((updatedRecentActivity, index) => index !== selectedIndex)
            .slice(0)
            .reverse();

        updatedSale.files = updatedFiles;
        await action.updateSale(selectedSale._id, updatedSale);

        await action.deleteFile(file, selectedSale._id);
    };

    const requestRemoveFile = (file, selectedIndex) => {
        setAttachmentDeleteTarget({ file, selectedIndex });
    };

    const confirmRemoveFile = async () => {
        if (!attachmentDeleteTarget) return;
        await removeFile(attachmentDeleteTarget.file, attachmentDeleteTarget.selectedIndex);
        setAttachmentDeleteTarget(null);
    };

    const cancelRemoveFile = () => {
        setAttachmentDeleteTarget(null);
    };

    const prevArray = () => {
        let prevProperties = [];
        flattenPrevArray.length = 0;

        const getPrevRecords = (obj) => {
            for (let property in obj) {
                if (property !== "recentActivities") {
                    if (typeof obj[property] === "object") {
                        prevProperties.push(property);
                        getPrevRecords(obj[property]);
                    } else {
                        if (prevProperties.length > 0) {
                            prevProperties.push(property);
                            flattenPrevArray.push({ [prevProperties]: obj[property] });
                            prevProperties.pop();
                        } else {
                            flattenPrevArray.push({ [property]: obj[property] });
                        }
                    }
                }
            }
            prevProperties.pop();
        };
        getPrevRecords(selectedSale);
    };

    const currArray = () => {
        let currProperties = [];
        flattenUpdatedArray.length = 0;

        const getCurrRecords = (obj) => {
            for (let property in obj) {
                if (property !== "recentActivities") {
                    if (typeof obj[property] === "object") {
                        currProperties.push(property);
                        getCurrRecords(obj[property]);
                    } else {
                        if (currProperties.length > 0) {
                            currProperties.push(property);
                            flattenUpdatedArray.push({ [currProperties]: obj[property] });
                            currProperties.pop();
                        } else {
                            flattenUpdatedArray.push({ [property]: obj[property] });
                        }
                    }
                }
            }
            currProperties.pop();
        };
        getCurrRecords(updatedSale);
    };

    const setRecentActivities = () => {
        prevArray();
        currArray();

        flattenPrevArray.map((prevArray) => {
            for (let prevProperties in prevArray) {
                flattenUpdatedArray.map((updatedArray) => {
                    for (let updatedProperties in updatedArray) {
                        if (
                            prevProperties === updatedProperties &&
                            prevArray[prevProperties] !== updatedArray[updatedProperties]
                        ) {
                            // push recent activities with date format
                            if (
                                prevProperties === "orderDate" ||
                                prevProperties === "expectedCompletionDate"
                            ) {
                                if (
                                    Moment(prevArray[prevProperties]).format("LL") !==
                                    Moment(updatedArray[prevProperties]).format("LL")
                                ) {
                                    // Update if recent activites was not already added
                                    if (
                                        !updatedSale.recentActivities.includes(
                                            `${Moment().format(
                                                "LLL",
                                            )}: ${prevProperties} was changed from '${Moment(
                                                prevArray[prevProperties],
                                            ).format("LL")}' to '${Moment(
                                                updatedArray[updatedProperties],
                                            ).format("LL")}'`,
                                        )
                                    ) {
                                        updatedSale.recentActivities.push(
                                            `${Moment().format(
                                                "LLL",
                                            )}: ${prevProperties} was changed from '${Moment(
                                                prevArray[prevProperties],
                                            ).format("LL")}' to '${Moment(
                                                updatedArray[updatedProperties],
                                            ).format("LL")}'`,
                                        );
                                    }
                                }
                                // Push recent activities with customer
                            } else if (prevProperties === "customerId") {
                                let prevCustomer = customerList.filter(
                                    (customer) => customer._id === prevArray[prevProperties],
                                );

                                let updatedCustomer = customerList.filter(
                                    (customer) => customer._id === updatedArray[updatedProperties],
                                );
                                // Update if recent activites was not already added
                                if (
                                    !updatedSale.recentActivities.includes(
                                        `${Moment().format(
                                            "LLL",
                                        )}: ${prevProperties} was changed from '${
                                            prevCustomer[0].firstName
                                        }' ${prevCustomer[0].lastName} to '${
                                            updatedCustomer[0].firstName
                                        }' ${updatedCustomer[0].lastName}`,
                                    )
                                ) {
                                    updatedSale.recentActivities.push(
                                        `${Moment().format(
                                            "LLL",
                                        )}: ${prevProperties} was changed from '${
                                            prevCustomer[0].firstName
                                        }' ${prevCustomer[0].lastName} to '${
                                            updatedCustomer[0].firstName
                                        }' ${updatedCustomer[0].lastName}`,
                                    );
                                }
                            } else {
                                // Update if recent activites was not already added
                                if (
                                    !updatedSale.recentActivities.includes(
                                        `${Moment().format(
                                            "LLL",
                                        )}: ${prevProperties} was changed from '${
                                            prevArray[prevProperties]
                                        }' to '${updatedArray[updatedProperties]}'`,
                                    )
                                ) {
                                    updatedSale.recentActivities.push(
                                        `${Moment().format(
                                            "LLL",
                                        )}: ${prevProperties} was changed from '${
                                            prevArray[prevProperties]
                                        }' to '${updatedArray[updatedProperties]}'`,
                                    );
                                }
                            }
                        }
                    }
                });
            }
        });
    };

    // PARTS LIST
    const [partsItem, setPartsItem] = useState({
        dateOrdered: Moment().utc().format("YYYY-MM-DD"),
        quantity: "",
        item: "",
        supplier: "",
        note: "",
        itemReceived: "",
        dateReceived: "",
    });

    const [addingPartsItemError, setAddingPartsItemError] = useState(false);
    const [showAddPartsForm, setShowAddPartsForm] = useState(false);

    const handleUpdateParts = (event) => {
        const { name, value } = event.target;

        setPartsItem({
            ...partsItem,
            [name]: value,
        });
    };

    const addPartsItem = async (event) => {
        if (event) {
            event.preventDefault();
        }

        try {
            if (partsItem.quantity === "") {
                setAddingPartsItemError(true);
            } else {
                setAddingPartsItemError(false);

                updatedSale.partsList.push(partsItem);

                await action.updateSale(selectedSale._id, updatedSale);
                setPartsItem({
                    dateOrdered: Moment().utc().format("YYYY-MM-DD"),
                    quantity: "",
                    item: "",
                    supplier: "",
                    note: "",
                    itemReceived: "",
                    dateReceived: "",
                });
                setShowAddPartsForm(false);
            }
        } catch (error) {
            console.log("Error adding parts item: ", error);
        }
    };

    const removePartsItem = async (selectedIndex) => {
        await action.setUpdating(true);
        try {
            const updatedPartsList = (updatedSale.partsList || []).filter(
                (_, index) => index !== selectedIndex,
            );
            const nextSale = {
                ...updatedSale,
                partsList: updatedPartsList,
            };
            setUpdatedSale(nextSale);
            await action.updateSale(selectedSale._id, nextSale);
        } catch (error) {
            console.error("Error removing parts item:", error);
        } finally {
            await action.setUpdating(false);
        }
    };

    // PAINT LIST
    const [paintItem, setPaintItem] = useState({
        quantity: "",
        item: "",
        paintOut: "",
        paintIn: "",
        note: "",
    });

    const [addingPaintItemError, setAddingPaintItemError] = useState(false);

    // GENERATE PDF
    const componentRef = useRef();

    const createPaintList = async () => {
        const paintList = {
            createdDate: Moment().format("LLL"),
            shipTo: "",
            items: [
                {
                    quantity: "",
                    item: "Door",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Sidelights",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "EXEC. Panel",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Kick Panel",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Sweep Cover",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Sweep",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Lite Frame",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Astragal",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "EXT. Astragal",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Shoes",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Screens",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Screen Track",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "4-5/8 Jamb",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "6-5/8 Jamb",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "4-5/8 Post",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Boots",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: '2" Brickmould',
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Brickmould",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Flat Brickmould",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Patio Post",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Jamb EXT.",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Transoms",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Transom Trim",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Trim",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Burlap",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Casing",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Sill Cap",
                    side: "",
                    colour: "",
                },
                {
                    quantity: "",
                    item: "Touch Up",
                    side: "",
                    colour: "",
                },
            ],
            pickedUp: false,
            pickedUpDate: "",
            specialNotes: "",
            verifiedBy: "",
        };

        try {
            const nextSale = {
                ...updatedSale,
                paintList,
            };
            setUpdatedSale(nextSale);
            setEditForm(true);
            await action.updateSale(selectedSale._id, nextSale);
        } catch (error) {
            console.log("Error adding paint list: ", error);
        }
    };

    const handleUpdatePaint = (event) => {
        event.preventDefault();
        const { name, value } = event.target;

        setPaintItem({
            ...paintItem,
            [name]: value,
        });
    };

    const addPaintItem = async (event) => {
        event.preventDefault();

        try {
            if (paintItem.quantity === "") {
                setAddingPaintItemError(true);
            } else {
                setAddingPaintItemError(false);
                if (paintItem.paintOut === "") {
                    paintItem.paintOut = updatedSale.productSpecification.doorLeft.paintOut;
                }

                if (paintItem.paintIn === "") {
                    paintItem.paintIn = updatedSale.productSpecification.doorLeft.paintIn;
                }

                updatedSale.paintList.items.push(paintItem);

                await action.updateSale(selectedSale._id, updatedSale);
                setPaintItem({
                    quantity: "",
                    item: "",
                    paintOut: "",
                    paintIn: "",
                    note: "",
                });
            }
        } catch (error) {
            console.log("Error adding paint item: ", error);
        }
    };

    const removePaintItem = async () => {
        await action.setUpdating(true);
        try {
            const nextSale = { ...updatedSale, paintList: {} };
            setUpdatedSale(nextSale);
            await action.updateSale(selectedSale._id, nextSale);
        } catch (error) {
            console.error("Error removing paint list:", error);
        } finally {
            await action.setUpdating(false);
        }
    };

    const handleUpdate = (set, field, value, name) => {
        if (
            field === "po" ||
            field === "cost" ||
            field === "labourCost" ||
            field === "salesPrice" ||
            field === "orderDate" ||
            field === "customerId" ||
            field === "contractor" ||
            field === "product" ||
            field === "paymentMethod" ||
            field === "expectedCompletionDate" ||
            field === "completionDate"
        ) {
            if (field === "orderDate" || field === "expectedCompletionDate") {
                set((state) => ({
                    ...state,
                    [field]: Moment(value).format("LLLL"),
                }));
            } else {
                set((state) => ({
                    ...state,
                    [field]: value,
                }));
            }
        } else if (
            field === "doorSystem" ||
            field === "brickToBrick" ||
            field === "lock" ||
            field === "sill" ||
            field === "sillExtension"
        ) {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    [field]: value,
                },
            }));
        } else if (name === "jamb") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    jamb: {
                        ...state.productSpecification.jamb,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "doorLeft") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorLeft: {
                        ...state.productSpecification.doorLeft,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "doorLeftInsert") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorLeft: {
                        ...state.productSpecification.doorLeft,
                        doorInsert: {
                            ...state.productSpecification.doorLeft.doorInsert,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorLeftLock") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorLeft: {
                        ...state.productSpecification.doorLeft,
                        lock: {
                            ...state.productSpecification.doorLeft.lock,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorLeftHinge") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorLeft: {
                        ...state.productSpecification.doorLeft,
                        hinge: {
                            ...state.productSpecification.doorLeft.hinge,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorMiddle") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorMiddle: {
                        ...state.productSpecification.doorMiddle,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "doorMiddleInsert") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorMiddle: {
                        ...state.productSpecification.doorMiddle,
                        doorInsert: {
                            ...state.productSpecification.doorMiddle.doorInsert,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorMiddleLock") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorMiddle: {
                        ...state.productSpecification.doorMiddle,
                        lock: {
                            ...state.productSpecification.doorMiddle.lock,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorMiddleHinge") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorMiddle: {
                        ...state.productSpecification.doorMiddle,
                        hinge: {
                            ...state.productSpecification.doorMiddle.hinge,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorRight") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorRight: {
                        ...state.productSpecification.doorRight,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "doorRightInsert") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorRight: {
                        ...state.productSpecification.doorRight,
                        doorInsert: {
                            ...state.productSpecification.doorRight.doorInsert,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorRightLock") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorRight: {
                        ...state.productSpecification.doorRight,
                        lock: {
                            ...state.productSpecification.doorRight.lock,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (name === "doorRightHinge") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorRight: {
                        ...state.productSpecification.doorRight,
                        hinge: {
                            ...state.productSpecification.doorRight.hinge,
                            [field]: value,
                        },
                    },
                },
            }));
        } else if (field === "frameSizeHeight") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    frameSize: {
                        ...state.productSpecification.frameSize,
                        height: value,
                    },
                },
            }));
        } else if (field === "frameSizeWidth") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    frameSize: {
                        ...state.productSpecification.frameSize,
                        width: value,
                    },
                },
            }));
        } else if (name === "sidelightLeft") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    sidelightLeft: {
                        ...state.productSpecification.sidelightLeft,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "sidelightRight") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    sidelightRight: {
                        ...state.productSpecification.sidelightRight,
                        [field]: value,
                    },
                },
            }));
        } else if (name === "transom") {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    transom: {
                        ...state.productSpecification.transom,
                        [field]: value,
                    },
                },
            }));
        } else if (field === "installationRequired" || field === "status") {
            // time stamp completion date if status equals completed
            if (field === "status") {
                if (value === "Completed") {
                    setUpdatedSale({
                        ...updatedSale,
                        completionDate: Moment().format("LL"),
                    });
                } else if (value !== "Completed") {
                    setUpdatedSale({
                        ...updatedSale,
                        completionDate: "",
                    });
                }
            }

            set((state) => ({
                ...state,
                workOrder: {
                    ...state.workOrder,
                    [field]: value,
                },
            }));
        }
    };

    const handleUpdateList = (set, field, value, name, currentIndex) => {
        if (name === "paintList") {
            set((state) => ({
                ...state,
                paintList: {
                    ...state.paintList,

                    [field]: value,
                },
            }));
        } else if (name === "paintListItem") {
            if (field === "quantity") {
                if (updatedSale.paintList.items[currentIndex].colour === "") {
                    updatedSale.paintList.items[currentIndex].colour =
                        updatedSale.productSpecification.doorLeft.paintOut;
                }
            }
            set((state) => ({
                ...state,
                paintList: {
                    ...state.paintList,
                    items: state.paintList.items.map((item, index) =>
                        index === currentIndex ? { ...item, [field]: value } : item,
                    ),
                },
            }));
        } else if (name === "paintListDate") {
            set((state) => ({
                ...state,
                paintList: {
                    ...state.paintList,

                    [field]: Moment(value).format("LLLL"),
                },
            }));
        } else if (name === "partsList") {
            set((state) => ({
                ...state,
                partsList: state.partsList.map((item, index) =>
                    index === currentIndex ? { ...item, [field]: value } : item,
                ),
            }));
        } else if (name === "partsListDate") {
            set((state) => ({
                ...state,
                partsList: state.partsList.map((item, index) =>
                    index === currentIndex
                        ? { ...item, [field]: Moment(value).format("LLLL") }
                        : item,
                ),
            }));
        }
    };

    const handleUpdateCheckbox = async (event) => {
        try {
            const { name, checked } = event.target;

            if (name === "pickedUp") {
                updatedSale.paintList.pickedUp = checked;
                if (checked) {
                    if (updatedSale.paintList.pickedUpDate === "") {
                        updatedSale.paintList.pickedUpDate = Moment();
                    }
                } else {
                    updatedSale.paintList.pickedUpDate = "";
                }
            } else if (name === "itemReceived") {
                updatedSale.partsList.itemReceived = checked;
                if (checked) {
                    if (updatedSale.partsList.dateReceived === "") {
                        updatedSale.partsList.dateReceived = Moment();
                    }
                } else {
                    updatedSale.partsList.dateReceived = "";
                }
            }

            await action.updateSale(selectedSale._id, updatedSale);
        } catch (error) {
            console.log("Error updating drop off field: ", error);
        }
    };

    const handleUpdatePartsListCheckbox = async (event, index) => {
        try {
            const { name, checked } = event.target;

            if (name === "itemReceived") {
                updatedSale.partsList[index].itemReceived = checked;
                if (checked) {
                    if (updatedSale.partsList[index].dateReceived === "") {
                        updatedSale.partsList[index].dateReceived = Moment();
                    }
                } else {
                    updatedSale.partsList[index].dateReceived = "";
                }
            }

            await action.updateSale(selectedSale._id, updatedSale);
        } catch (error) {
            console.log("Error updating drop off field: ", error);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            await action.updateSale(selectedSale._id, updatedSale);
            setEditForm(false);
            setPaintSectionEditMode(false);
            openSaleModal(selectedSale._id);
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const cancelPaintSectionEdit = (event) => {
        event.preventDefault();
        setPaintSectionEditMode(false);
        const pl = selectedSale.paintList;
        setUpdatedSale((prev) => ({
            ...prev,
            paintList: pl != null ? JSON.parse(JSON.stringify(pl)) : prev.paintList,
        }));
    };

    const savePaintSection = async (event) => {
        event.preventDefault();
        try {
            await action.updateSale(selectedSale._id, updatedSale);
            setPaintSectionEditMode(false);
            openSaleModal(selectedSale._id);
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const cancelSpecSection = () => {
        setSpecSectionEditMode(false);
        setUpdatedSale((prev) => ({
            ...prev,
            productSpecification: selectedSale.productSpecification || {},
        }));
    };

    const saveSpecSection = async () => {
        try {
            await action.updateSale(selectedSale._id, updatedSale);
            setSpecSectionEditMode(false);
            openSaleModal(selectedSale._id);
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const inputField = (labelName, inputName, value, type, disable, name) => {
        const hasValue = value !== null && value !== undefined && String(value).trim() !== "";
        const isPriceField =
            inputName === "cost" || inputName === "labourCost" || inputName === "salesPrice";
        const displayValue = disable ? value || "" : hasValue ? value : "—";

        return (
            <div className="Sale-form-input-row">
                <label htmlFor={inputName}>{labelName}</label>
                <div className="Sale-field-value">
                    {isPriceField && hasValue && <span className="currency">$</span>}
                    <input
                        className="Sale-form-input"
                        type={type}
                        id={inputName}
                        name={inputName}
                        value={displayValue}
                        onChange={(event) =>
                            handleUpdate(setUpdatedSale, inputName, event.target.value, name)
                        }
                        onBlur={setRecentActivities}
                        disabled={!disable}
                    />
                </div>
            </div>
        );
    };

    const addNote = (note) => {
        updatedSale.notes.push(note);

        action.updateSale(selectedSale._id, updatedSale);
    };

    const removeNote = (selectedIndex) => {
        const updatedNotes = updatedSale.notes
            .slice(0)
            .reverse()
            .filter((note, index) => index !== selectedIndex)
            .slice(0)
            .reverse();

        updatedSale.notes = updatedNotes;
    };

    const removeRecentActivity = (selectedIndex) => {
        const updatedRecentActivities = updatedSale.recentActivities
            .slice(0)
            .reverse()
            .filter((updatedRecentActivity, index) => index !== selectedIndex)
            .slice(0)
            .reverse();

        updatedSale.recentActivities = updatedRecentActivities;
    };

    const toggleButton = () => {
        if (!editForm) {
            return (
                <div className="Sale-edit-btn">
                    <Button
                        variant="secondary"
                        size="sm"
                        className="detail-action-btn"
                        onClick={toggleForm}
                        leadingIcon={<i className="fas fa-pen" aria-hidden="true" />}
                    >
                        Edit
                    </Button>
                </div>
            );
        } else {
            return (
                <div className="Sale-edit-btn">
                    <Button
                        type="button"
                        variant="secondary"
                        size="sm"
                        className="detail-action-btn"
                        onClick={toggleForm}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="primary"
                        size="sm"
                        className="detail-action-btn"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                </div>
            );
        }
    };

    const toggleForm = (event) => {
        event.preventDefault();
        setEditForm(!editForm);

        if (event.target.innerHTML === "Cancel") {
            setPaintSectionEditMode(false);
            setUpdatedSale({
                orderDate: Moment(selectedSale.orderDate).format("YYYY-MM-DD"),
                contractor: selectedSale.contractor,
                customerId: selectedSale.customerId,
                po: selectedSale.po,
                product: selectedSale.product,
                productSpecification: selectedSale.productSpecification,
                paymentMethod: selectedSale.paymentMethod,
                cost: selectedSale.cost,
                labourCost: selectedSale.labourCost,
                salesPrice: selectedSale.salesPrice,
                payments: selectedSale.payments,
                workOrder: selectedSale.workOrder,
                expectedCompletionDate: Moment(selectedSale.expectedCompletionDate).format(
                    "YYYY-MM-DD",
                ),
                completionDate: selectedSale.completionDate,
                notes: selectedSale.notes,
                recentActivities: selectedSale.recentActivities,
                files: updatedSale.files,
                paintList: selectedSale.paintList
                    ? JSON.parse(JSON.stringify(selectedSale.paintList))
                    : updatedSale.paintList,
                partsList: selectedSale.partsList,
            });
        }
    };

    const getOutstandingBalance = () => {
        const collected = (updatedSale.payments || []).reduce(
            (sum, payment) => sum + (parseFloat(payment.amount) || 0),
            0,
        );
        return (parseFloat(updatedSale.salesPrice) || 0) - collected;
    };

    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined || Number.isNaN(amount)) {
            return "—";
        }
        const rounded = Math.round(amount * 100) / 100;
        return `$${rounded}`;
    };

    const selectedCustomer = customerList.find(
        (customer) => customer._id === updatedSale.customerId,
    );
    const summaryCustomerName = selectedCustomer
        ? `${selectedCustomer.firstName || ""} ${selectedCustomer.lastName || ""}`.trim()
        : "";
    const summaryOrderDate = updatedSale.orderDate
        ? Moment(updatedSale.orderDate).format("YYYY-MM-DD")
        : "";
    const summaryStatus = updatedSale.workOrder?.status || "";
    const summaryBalanceAmount = getOutstandingBalance();
    const summaryBalance = formatCurrency(summaryBalanceAmount);
    const balanceTabAmountClass =
        summaryBalanceAmount < 0
            ? "Sale-balance-amount--credit"
            : summaryBalanceAmount > 0
              ? "Sale-balance-amount--due"
              : "Sale-balance-amount--zero";
    const balanceSummaryCardClass =
        summaryBalanceAmount > 0 ? "Sale-balance-summary--due" : "Sale-balance-summary--cleared";
    const workOrderStatus = updatedSale.workOrder?.status || "";
    const statusTone =
        workOrderStatus === "Completed"
            ? "success"
            : workOrderStatus.toLowerCase().includes("pending")
              ? "warning"
              : "neutral";

    const hasPaintList =
        Array.isArray(updatedSale.paintList?.items) && updatedSale.paintList.items.length > 0;

    const addPayment = (payment) => {
        const nextPayments = [...(updatedSale.payments || []), payment];
        const nextSale = { ...updatedSale, payments: nextPayments };
        setUpdatedSale(nextSale);
        action.updateSale(selectedSale._id, nextSale);
    };

    const removePayment = (selectedIndex) => {
        const updatedPayments = updatedSale.payments.filter(
            (payment, index) => index !== selectedIndex,
        );
        const nextSale = { ...updatedSale, payments: updatedPayments };
        setUpdatedSale(nextSale);
        action.updateSale(selectedSale._id, nextSale);
        if (editPaymentModalOpen && selectedPaymentStorageIndex === selectedIndex) {
            setEditPaymentModalOpen(false);
            setSelectedPaymentStorageIndex(null);
        }
    };

    const savePayment = async (storageIndex, draft) => {
        const descriptionTrimmed =
            draft.description != null ? String(draft.description).trim() : "";
        const nextPayments = updatedSale.payments.map((p, i) =>
            i === storageIndex
                ? {
                      ...p,
                      date: draft.date,
                      amount: draft.amount,
                      description:
                          descriptionTrimmed !== "" ? descriptionTrimmed : "Payment received",
                  }
                : p,
        );
        const nextSale = { ...updatedSale, payments: nextPayments };
        setUpdatedSale(nextSale);
        await action.updateSale(selectedSale._id, nextSale);
    };

    const closeEditPaymentModal = () => {
        setEditPaymentModalOpen(false);
        setSelectedPaymentStorageIndex(null);
    };

    const openEditPaymentModalForPayment = (paymentRow) => {
        const idx = updatedSale.payments.indexOf(paymentRow);
        if (idx !== -1) {
            setSelectedPaymentStorageIndex(idx);
            setEditPaymentModalOpen(true);
        }
    };

    const selectedPaymentRecord =
        selectedPaymentStorageIndex != null &&
        updatedSale.payments?.[selectedPaymentStorageIndex] != null
            ? updatedSale.payments[selectedPaymentStorageIndex]
            : null;

    const doorSystem = updatedSale.productSpecification?.doorSystem || "";
    const showMiddleDoorPanel = doorSystem === "Double Door" || doorSystem === "Triple Door";
    const showRightDoorPanel = doorSystem === "Triple Door";

    useEffect(() => {
        if (activeSpecPanel === "doorRight" && !showRightDoorPanel) {
            setActiveSpecPanel(showMiddleDoorPanel ? "doorMiddle" : "doorLeft");
            return;
        }
        if (activeSpecPanel === "doorMiddle" && !showMiddleDoorPanel) {
            setActiveSpecPanel("doorLeft");
        }
    }, [activeSpecPanel, showMiddleDoorPanel, showRightDoorPanel]);

    const paymentsSortedByDate = useMemo(() => {
        const list = updatedSale.payments || [];
        return [...list].sort((a, b) => Moment(a.date).valueOf() - Moment(b.date).valueOf());
    }, [updatedSale.payments, updatedSale.payments?.length]);

    const paymentBalanceAfterEach = useMemo(() => {
        let running = parseFloat(updatedSale.salesPrice) || 0;
        return paymentsSortedByDate.map((pay) => {
            running -= parseFloat(pay.amount) || 0;
            return running;
        });
    }, [paymentsSortedByDate, updatedSale.salesPrice]);

    const paymentBalanceAfterTone = (amount) =>
        amount < 0
            ? "Sale-balance-amount--credit"
            : amount > 0
              ? "Sale-balance-amount--due"
              : "Sale-balance-amount--zero";

    const paymentTableColumns = [
        {
            id: "date",
            header: "Date",
            cell: (p) => Moment(p.date).format("LL"),
        },
        {
            id: "description",
            header: "Description",
            cell: (p) =>
                p.description != null && String(p.description).trim() !== ""
                    ? String(p.description).trim()
                    : "Payment received",
        },
        {
            id: "amount",
            header: "Amount",
            align: "right",
            headerClassName: "Sale-balance-table-th-amount",
            cellClassName: "Sale-balance-table-amount",
            cell: (p) => formatCurrency(p.amount),
        },
        {
            id: "balanceAfter",
            header: "Balance after",
            align: "right",
            headerClassName: "Sale-balance-table-th-balance-after",
            cellClassName: (_, rowIndex) =>
                `Sale-balance-table-balance-after ${paymentBalanceAfterTone(
                    paymentBalanceAfterEach[rowIndex],
                )}`,
            cell: (_, rowIndex) => formatCurrency(paymentBalanceAfterEach[rowIndex]),
        },
        ...(editForm
            ? [
                  {
                      id: "actions",
                      header: <span className="sr-only">Actions</span>,
                      align: "center",
                      headerClassName: "Sale-balance-table-th-actions",
                      cellClassName: "Sale-balance-table-actions",
                      cell: (p) => (
                          <button
                              type="button"
                              className="Sale-balance-remove"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  const origIndex = updatedSale.payments.indexOf(p);
                                  if (origIndex !== -1) removePayment(origIndex);
                              }}
                              aria-label="Remove payment"
                          >
                              <i className="fas fa-trash-alt" aria-hidden="true" />
                          </button>
                      ),
                  },
              ]
            : []),
    ];

    return (
        <div className="Sale">
            <SaleSummaryHeader
                status={summaryStatus || "—"}
                balance={summaryBalance}
                balanceAmount={summaryBalanceAmount}
                orderDate={summaryOrderDate || "—"}
                purchaseOrder={updatedSale.po || "—"}
                customer={summaryCustomerName || "—"}
            />

            <div className="Sale-section Sale-main-layout">
                <div className="Sale-top-left-container">
                    <div style={{ width: "100%" }}>
                        <form>
                            <div className="Sale-section-header">
                                <h5>SALES INFORMATION</h5>
                                {toggleButton()}
                            </div>
                            {inputField(
                                "Order Date",
                                "orderDate",
                                Moment(updatedSale.orderDate).utc().format("YYYY-MM-DD"),
                                "date",
                                editForm,
                            )}
                            <div className="Sale-form-input-row">
                                <label htmlFor="contractor">Contractor</label>
                                <select
                                    className="Sale-form-input"
                                    id="contractor"
                                    name="contractor"
                                    value={updatedSale.contractor}
                                    onChange={(event) =>
                                        handleUpdate(
                                            setUpdatedSale,
                                            "contractor",
                                            event.target.value,
                                        )
                                    }
                                    onBlur={setRecentActivities}
                                    disabled={!editForm}
                                >
                                    <option value=""></option>
                                    {customerList.map((customer, index) => {
                                        if (customer.contractor === "Yes") {
                                            return (
                                                <option
                                                    key={index}
                                                    value={`${customer.firstName} ${customer.lastName}`}
                                                >
                                                    {customer.firstName} {customer.lastName}
                                                </option>
                                            );
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="Sale-form-input-row">
                                <label htmlFor="customerId">Customer</label>
                                <select
                                    className="Sale-form-input"
                                    id="customerId"
                                    name="customerId"
                                    value={updatedSale.customerId}
                                    onChange={(event) =>
                                        handleUpdate(
                                            setUpdatedSale,
                                            "customerId",
                                            event.target.value,
                                        )
                                    }
                                    onBlur={setRecentActivities}
                                    disabled={!editForm}
                                >
                                    {customerList.map((customer, index) => {
                                        return (
                                            <option key={index} value={customer._id}>
                                                {customer.firstName} {customer.lastName}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            {inputField("PO", "po", updatedSale.po, "text", editForm)}

                            <div className="Sale-form-input-row">
                                <label htmlFor="product">Product</label>
                                <select
                                    className="Sale-form-input"
                                    id="product"
                                    name="product"
                                    value={updatedSale.product}
                                    onChange={(event) =>
                                        handleUpdate(setUpdatedSale, "product", event.target.value)
                                    }
                                    onBlur={setRecentActivities}
                                    disabled={!editForm}
                                >
                                    <option value="Door">Door</option>
                                    <option value="Glass">Glass</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            {inputField("Cost", "cost", updatedSale.cost, "number", editForm)}
                            {inputField(
                                "Labour Cost",
                                "labourCost",
                                updatedSale.labourCost,
                                "number",
                                editForm,
                            )}
                            {inputField(
                                "Sales Price",
                                "salesPrice",
                                updatedSale.salesPrice,
                                "number",
                                editForm,
                            )}

                            <div className="Sale-form-input-row">
                                <label htmlFor="paymentMethod">Payment Method</label>
                                <select
                                    className="Sale-form-input"
                                    id="paymentMethod"
                                    name="paymentMethod"
                                    value={updatedSale.paymentMethod}
                                    onChange={(event) =>
                                        handleUpdate(
                                            setUpdatedSale,
                                            "paymentMethod",
                                            event.target.value,
                                        )
                                    }
                                    onBlur={setRecentActivities}
                                    disabled={!editForm}
                                >
                                    <option value="">Select</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="Credit Card">Credit Card</option>
                                    <option value="Debit">Debit</option>
                                    <option value="E-Transfer">E-Transfer</option>
                                </select>
                            </div>

                            <div className="Sale-form-input-row">
                                <label htmlFor="createdDate">Created On:</label>
                                <input
                                    className="Sale-form-input"
                                    id="createdDate"
                                    name="createdDate"
                                    value={Moment(selectedSale.createdDate).format("LLL")}
                                    disabled={true}
                                />
                            </div>
                            <div className="Sale-form-input-row">
                                <label htmlFor="updatedDate">Last Updated</label>
                                <input
                                    className="Sale-form-input"
                                    id="updatedDate"
                                    name="updatedDate"
                                    value={Moment(selectedSale.updatedDate).format("LLL")}
                                    disabled={true}
                                />
                            </div>
                        </form>

                        <div className="Sale-details-stack">
                            <section className="Sale-inline-section">
                                <div className="Sale-card-header">
                                    <h5 className="detail-section-title">Notes</h5>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        className="detail-action-btn Sale-inline-add-note-btn"
                                        onClick={() => setShowNotesModal(true)}
                                        leadingIcon={
                                            <i className="fas fa-plus" aria-hidden="true" />
                                        }
                                    >
                                        Add Note
                                    </Button>
                                </div>
                                <div className="Sale-top-right-ra-section Sale-inline-notes-body">
                                    {updatedSale.notes && updatedSale.notes.length > 0 ? (
                                        updatedSale.notes
                                            .slice(0)
                                            .reverse()
                                            .map((note, index) => {
                                                return (
                                                    <div className="note-card" key={index}>
                                                        <p className="note-card-date">
                                                            {Moment(note.date).format("LLL")}
                                                        </p>
                                                        <p className="note-card-text">
                                                            {note.description}
                                                        </p>
                                                        {editForm && (
                                                            <button
                                                                className="close"
                                                                onClick={() => removeNote(index)}
                                                            >
                                                                x
                                                            </button>
                                                        )}
                                                    </div>
                                                );
                                            })
                                    ) : (
                                        <div className="Sale-empty-state">No notes yet.</div>
                                    )}
                                </div>

                                <NoteModal
                                    showNotesModal={showNotesModal}
                                    setShowNotesModal={setShowNotesModal}
                                    addNote={addNote}
                                />
                            </section>
                        </div>
                    </div>
                </div>

                <div className="Sale-top-right-container">
                    <ScrollableTabs>
                    <Tabs defaultActiveKey="details" id="sale-details-tabs">
                        <Tab eventKey="details" title="Details">
                            <div className="Sale-details-stack">
                                <section className="Sale-detail-block">
                                    <h5 className="detail-section-title">Work Order</h5>
                                    <div className="Sale-top-right-workOrder">
                                        <div>
                                            <div className="Sale-form-input-row">
                                                <label htmlFor="installationRequired">
                                                    Installation Required
                                                </label>
                                                <select
                                                    className="Sale-form-input"
                                                    id="installationRequired"
                                                    name="installationRequired"
                                                    value={
                                                        updatedSale.workOrder.installationRequired
                                                    }
                                                    onChange={(event) =>
                                                        handleUpdate(
                                                            setUpdatedSale,
                                                            "installationRequired",
                                                            event.target.value,
                                                        )
                                                    }
                                                    onBlur={setRecentActivities}
                                                    disabled={!editForm}
                                                >
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            </div>

                                            {inputField(
                                                "Expected Completion Date",
                                                "expectedCompletionDate",
                                                Moment(updatedSale.expectedCompletionDate).format(
                                                    "YYYY-MM-DD",
                                                ),
                                                "date",
                                                editForm,
                                            )}

                                            <div className="Sale-form-input-row">
                                                <label htmlFor="status">Status</label>
                                                {editForm ? (
                                                    <select
                                                        className="Sale-form-input"
                                                        id="status"
                                                        name="status"
                                                        value={updatedSale.workOrder.status}
                                                        onChange={(event) =>
                                                            handleUpdate(
                                                                setUpdatedSale,
                                                                "status",
                                                                event.target.value,
                                                            )
                                                        }
                                                        onBlur={setRecentActivities}
                                                        disabled={!editForm}
                                                    >
                                                        {statusList.map((status, index) => {
                                                            return (
                                                                <option
                                                                    key={index}
                                                                    value={status.status}
                                                                >
                                                                    {status.status}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                ) : (
                                                    <div className="Sale-status-cell">
                                                        <Badge tone={statusTone}>
                                                            {updatedSale.workOrder.status || "—"}
                                                        </Badge>
                                                    </div>
                                                )}
                                            </div>

                                            {inputField(
                                                "Completion Date",
                                                "completionDate",
                                                updatedSale.completionDate,
                                                "text",
                                                editForm,
                                            )}
                                        </div>
                                    </div>
                                </section>

                                <SalePartsSection
                                    editForm={editForm}
                                    partsList={updatedSale.partsList || []}
                                    updating={updating}
                                    onAddClick={() => {
                                        setAddingPartsItemError(false);
                                        setShowAddPartsForm(true);
                                    }}
                                    addFormOpen={showAddPartsForm}
                                    onCloseAddForm={() => {
                                        setAddingPartsItemError(false);
                                        setShowAddPartsForm(false);
                                    }}
                                    partsItem={partsItem}
                                    onPartsFieldChange={handleUpdateParts}
                                    onSubmitAdd={addPartsItem}
                                    addingPartsItemError={addingPartsItemError}
                                    onSavePart={async (index, draftPart) => {
                                        const nextPartsList = (updatedSale.partsList || []).map(
                                            (item, i) =>
                                                i === index
                                                    ? {
                                                          ...item,
                                                          dateOrdered: draftPart.dateOrdered,
                                                          quantity: draftPart.quantity,
                                                          supplier: draftPart.supplier,
                                                          item: draftPart.item,
                                                          note: draftPart.note,
                                                          itemReceived: Boolean(
                                                              draftPart.itemReceived,
                                                          ),
                                                          dateReceived:
                                                              draftPart.dateReceived !==
                                                                  undefined &&
                                                              draftPart.dateReceived !== ""
                                                                  ? Moment(
                                                                        draftPart.dateReceived,
                                                                    ).format("LLLL")
                                                                  : item.dateReceived,
                                                      }
                                                    : item,
                                        );
                                        const nextSale = {
                                            ...updatedSale,
                                            partsList: nextPartsList,
                                        };
                                        setUpdatedSale(nextSale);
                                        await action.updateSale(selectedSale._id, nextSale);
                                    }}
                                    onRemove={removePartsItem}
                                    onFieldBlur={setRecentActivities}
                                />

                                <section className="Sale-detail-block Sale-paint-section">
                                    <div className="Sale-card-header">
                                        <h5 className="detail-section-title">Paint</h5>
                                        {hasPaintList && (
                                            <div className="Sale-paint-header-actions">
                                                {!paintSectionEditMode ? (
                                                    <Button
                                                        type="button"
                                                        variant="secondary"
                                                        size="sm"
                                                        className="detail-action-btn"
                                                        onClick={() =>
                                                            setPaintSectionEditMode(true)
                                                        }
                                                        leadingIcon={
                                                            <i
                                                                className="fas fa-pen"
                                                                aria-hidden="true"
                                                            />
                                                        }
                                                    >
                                                        Edit
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button
                                                            type="button"
                                                            variant="secondary"
                                                            size="sm"
                                                            className="detail-action-btn"
                                                            onClick={cancelPaintSectionEdit}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="button"
                                                            variant="primary"
                                                            size="sm"
                                                            className="detail-action-btn"
                                                            onClick={savePaintSection}
                                                        >
                                                            Save
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className={
                                            hasPaintList
                                                ? "Sale-paint-section-body"
                                                : "Sale-paint-section-body Sale-paint-section-body--no-list"
                                        }
                                    >
                                        {hasPaintList ? (
                                            <ComponentToPrint
                                                ref={componentRef}
                                                updatedSale={updatedSale}
                                                selectedSale={selectedSale}
                                                paintEditForm={paintSectionEditMode}
                                                handleUpdateList={handleUpdateList}
                                                setUpdatedSale={setUpdatedSale}
                                                setRecentActivities={setRecentActivities}
                                                handleUpdateCheckbox={handleUpdateCheckbox}
                                                removePaintItem={removePaintItem}
                                                updating={updating}
                                                paintItem={paintItem}
                                                handleUpdatePaint={handleUpdatePaint}
                                                addPaintItem={addPaintItem}
                                                addingPaintItemError={addingPaintItemError}
                                                createPaintList={createPaintList}
                                            />
                                        ) : (
                                            <div className="Sale-paint-empty">
                                                <p className="Sale-paint-empty-text">
                                                    No paint list yet. Create one to send to the
                                                    finisher.
                                                </p>
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={createPaintList}
                                                >
                                                    Create paint list
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                    {hasPaintList && (
                                        <div className="Sale-paint-print-footer">
                                            <ReactToPrint
                                                pageStyle={PAINT_PRINT_PAGE_STYLE}
                                                trigger={() => (
                                                    <Button
                                                        type="button"
                                                        variant="secondary"
                                                        size="sm"
                                                        className="detail-action-btn"
                                                        leadingIcon={
                                                            <i
                                                                className="fas fa-print"
                                                                aria-hidden="true"
                                                            />
                                                        }
                                                    >
                                                        Print
                                                    </Button>
                                                )}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                    )}
                                </section>
                            </div>
                        </Tab>

                        <Tab eventKey="balance" title="Balance">
                            <section className="Sale-detail-block">
                                <div className="Sale-card-header">
                                    <h5 className="detail-section-title">Balance</h5>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        className="detail-action-btn"
                                        onClick={() => setPaymentModalShow(true)}
                                        leadingIcon={
                                            <i className="fas fa-plus" aria-hidden="true" />
                                        }
                                    >
                                        Add Payment
                                    </Button>
                                </div>
                                <div className="Sale-balance-content">
                                    <div
                                        className={`Sale-balance-summary ${balanceSummaryCardClass}`}
                                    >
                                        <span className="Sale-balance-summary-label">
                                            Outstanding balance
                                        </span>
                                        <span
                                            className={`Sale-balance-amount ${balanceTabAmountClass}`}
                                        >
                                            {formatCurrency(summaryBalanceAmount)}
                                        </span>
                                    </div>

                                    {updatedSale.payments && updatedSale.payments.length > 0 ? (
                                        <SaleRecordTable
                                            columns={paymentTableColumns}
                                            rows={paymentsSortedByDate}
                                            getRowKey={(payment, index) =>
                                                `payment-${index}-${payment.date}-${payment.amount}`
                                            }
                                            tableClassName="Sale-balance-table"
                                            onRowClick={(paymentRow) =>
                                                openEditPaymentModalForPayment(paymentRow)
                                            }
                                        />
                                    ) : (
                                        <div className="Sale-empty-state Sale-empty-state--balance">
                                            No payments recorded yet.
                                        </div>
                                    )}

                                    <PaymentModal
                                        paymentModalShow={paymentModalShow}
                                        setPaymentModalShow={setPaymentModalShow}
                                        addPayment={addPayment}
                                    />
                                    <SaleEditPaymentModal
                                        open={editPaymentModalOpen}
                                        onClose={closeEditPaymentModal}
                                        payment={selectedPaymentRecord}
                                        paymentStorageIndex={selectedPaymentStorageIndex}
                                        formatCurrency={formatCurrency}
                                        onSavePayment={savePayment}
                                        onRemovePayment={removePayment}
                                    />
                                </div>
                            </section>
                        </Tab>

                        <Tab eventKey="attachments" title="Attachments">
                            <section className="Sale-detail-block Sale-attachments-section">
                                <div className="Sale-card-header">
                                    <h5 className="detail-section-title">Attachments</h5>
                                </div>
                                <div className="Sale-attachments-section-body">
                                    <div
                                        {...getRootProps({
                                            className: `Sale-file-container${
                                                isDragActive
                                                    ? " Sale-file-container--drag-active"
                                                    : ""
                                            }`,
                                        })}
                                    >
                                        <input {...getInputProps()} />
                                        {queueingFiles ? (
                                            <div className="Sale-file-queued-loading">
                                                <Spinner size="sm" />
                                                <p className="Sale-file-queued-loading-text">
                                                    Adding file to queue...
                                                </p>
                                            </div>
                                        ) : files.length > 0 ? (
                                            <div className="Sale-file-queued-state">
                                                <p className="Sale-file-queued-title">
                                                    Ready to upload ({files.length})
                                                </p>
                                                <div className="Sale-file-queued-list">
                                                    {files.map((file) => (
                                                        <div
                                                            key={file[0].path || file[0].name}
                                                            className="Sale-file-queued-item"
                                                        >
                                                            {file[0].path || file[0].name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="Sale-paint-empty-text">
                                                {isDragActive
                                                    ? "Drop the files here…"
                                                    : "Drag files here or click to browse. Below, tap Add attachment to upload queued files."}
                                            </p>
                                        )}
                                    </div>
                                    <div className="Sale-attachments-add-actions">
                                        <Button
                                            type="button"
                                            variant="primary"
                                            size="sm"
                                            onClick={addFile}
                                            disabled={uploading}
                                        >
                                            {uploading ? "Uploading…" : "Add attachment"}
                                        </Button>
                                    </div>

                                    {uploadMessage === "Successful" && (
                                        <div className="Sale-attachments-feedback Sale-attachments-feedback--ok">
                                            <p>File successfully added.</p>
                                        </div>
                                    )}
                                    {uploadMessage === "Failed" && (
                                        <div className="Sale-attachments-feedback Sale-attachments-feedback--err">
                                            <p>Select or drop a file first.</p>
                                        </div>
                                    )}
                                </div>

                                <div className="Sale-attachments-saved">
                                    <p className="Sale-attachments-saved-heading">
                                        Saved attachments
                                    </p>
                                    {updatedSale.files && updatedSale.files.length > 0 ? (
                                        <ul
                                            className="Sale-attachments-list"
                                            aria-label="Uploaded files for this sale"
                                        >
                                            {updatedSale.files
                                                .slice(0)
                                                .reverse()
                                                .map((file, index) => (
                                                    <li
                                                        key={`${file}-${index}`}
                                                        className="Sale-attachment-item"
                                                    >
                                                        <button
                                                            type="button"
                                                            className="Sale-attachment-tile"
                                                            onClick={() =>
                                                                openAttachmentInBrowser(file)
                                                            }
                                                        >
                                                            <span
                                                                className="Sale-attachment-tile-icon"
                                                                aria-hidden="true"
                                                            >
                                                                <i className="fas fa-file-alt" />
                                                            </span>
                                                            <span className="Sale-attachment-tile-body">
                                                                <span className="Sale-attachment-tile-name">
                                                                    {file}
                                                                </span>
                                                                <span className="Sale-attachment-tile-hint">
                                                                    Open in browser
                                                                </span>
                                                            </span>
                                                            <span
                                                                className="Sale-attachment-tile-chevron"
                                                                aria-hidden="true"
                                                            >
                                                                <i className="fas fa-external-link-alt" />
                                                            </span>
                                                        </button>
                                                        <div
                                                            className="Sale-attachment-item-actions"
                                                            role="group"
                                                            aria-label={`Actions for ${file}`}
                                                        >
                                                            <button
                                                                type="button"
                                                                className="Sale-attachment-action Sale-attachment-action--download"
                                                                onClick={() =>
                                                                    downloadAttachment(file)
                                                                }
                                                                aria-label={`Download ${file}`}
                                                                title="Download"
                                                            >
                                                                <i
                                                                    className="fas fa-download"
                                                                    aria-hidden="true"
                                                                />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="Sale-attachment-action Sale-attachment-action--delete"
                                                                onClick={() =>
                                                                    requestRemoveFile(file, index)
                                                                }
                                                                aria-label={`Delete ${file}`}
                                                                title="Delete"
                                                            >
                                                                <i
                                                                    className="fas fa-trash-alt"
                                                                    aria-hidden="true"
                                                                />
                                                            </button>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                    ) : (
                                        <p className="Sale-attachments-saved-empty">
                                            No files uploaded for this sale yet.
                                        </p>
                                    )}
                                </div>
                                <ConfirmDialog
                                    open={Boolean(attachmentDeleteTarget)}
                                    title="Delete this attachment?"
                                    description="This file will be removed from this sale. You can't undo this action."
                                    confirmLabel="Delete"
                                    cancelLabel="Cancel"
                                    confirmVariant="danger"
                                    onConfirm={confirmRemoveFile}
                                    onCancel={cancelRemoveFile}
                                />
                            </section>
                        </Tab>

                        <Tab eventKey="recentActivities" title="Recent Activities">
                            <section className="Sale-detail-block">
                                <h5 className="detail-section-title">Recent Activities</h5>
                                <div className="Sale-top-right-ra-section Sale-activities-panel">
                                    {updatedSale.recentActivities &&
                                    updatedSale.recentActivities.length > 0 ? (
                                        <ul className="Sale-activities-list">
                                            {updatedSale.recentActivities
                                                .slice(0)
                                                .reverse()
                                                .map((recentActivity, index) => {
                                                    const dividerIdx = recentActivity.indexOf(": ");
                                                    const hasDivider = dividerIdx > 0;
                                                    const activityTime = hasDivider
                                                        ? recentActivity.slice(0, dividerIdx)
                                                        : "";
                                                    const activityText = hasDivider
                                                        ? recentActivity.slice(dividerIdx + 2)
                                                        : recentActivity;
                                                    const changedMatch = activityText.match(
                                                        /^(.*?) was changed from ["'](.*)["'] to ["'](.*)["']$/,
                                                    );
                                                    const addedMatch =
                                                        activityText.match(/^(.*?) was added\.$/);
                                                    return (
                                                        <li
                                                            className="Sale-activity-item"
                                                            key={`${recentActivity}-${index}`}
                                                        >
                                                            <div className="Sale-activity-main">
                                                                {activityTime ? (
                                                                    <p className="Sale-activity-time">
                                                                        {activityTime}
                                                                    </p>
                                                                ) : null}
                                                                <p className="Sale-activity-text">
                                                                    {changedMatch ? (
                                                                        <>
                                                                            <span className="Sale-activity-field">
                                                                                {changedMatch[1]}
                                                                            </span>
                                                                            <span className="Sale-activity-verb">
                                                                                {" "}
                                                                                changed{" "}
                                                                            </span>
                                                                            <span className="Sale-activity-value Sale-activity-value--from">
                                                                                {changedMatch[2] ===
                                                                                ""
                                                                                    ? "\u00A0"
                                                                                    : changedMatch[2]}
                                                                            </span>
                                                                            <span className="Sale-activity-verb">
                                                                                {" "}
                                                                                to{" "}
                                                                            </span>
                                                                            <span className="Sale-activity-value Sale-activity-value--to">
                                                                                {changedMatch[3] ===
                                                                                ""
                                                                                    ? "\u00A0"
                                                                                    : changedMatch[3]}
                                                                            </span>
                                                                        </>
                                                                    ) : addedMatch ? (
                                                                        <>
                                                                            <span className="Sale-activity-field">
                                                                                {addedMatch[1]}
                                                                            </span>
                                                                            <span className="Sale-activity-verb">
                                                                                {" "}
                                                                                was added
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        activityText
                                                                    )}
                                                                </p>
                                                            </div>
                                                            {editForm && (
                                                                <button
                                                                    type="button"
                                                                    className="Sale-activity-remove"
                                                                    onClick={() =>
                                                                        removeRecentActivity(index)
                                                                    }
                                                                    aria-label={`Remove activity ${activityText}`}
                                                                    title="Remove activity"
                                                                >
                                                                    <i
                                                                        className="fas fa-trash-alt"
                                                                        aria-hidden="true"
                                                                    />
                                                                </button>
                                                            )}
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    ) : (
                                        <div className="Sale-empty-state">
                                            No recent activity yet.
                                        </div>
                                    )}
                                </div>
                            </section>
                        </Tab>
                    </Tabs>
                    </ScrollableTabs>
                </div>
            </div>

            <SaleProductSpecificationsSection
                selectedSale={selectedSale}
                setSelectedSale={setSelectedSale}
            >
                <form className="Sale-product-specifications">
                    <div className="Sale-section-header">
                        <h5>SPECIFICATIONS</h5>
                        <div className="Sale-paint-header-actions">
                            {!specSectionEditMode ? (
                                <Button
                                    type="button"
                                    variant="secondary"
                                    size="sm"
                                    className="detail-action-btn"
                                    onClick={() => setSpecSectionEditMode(true)}
                                    leadingIcon={<i className="fas fa-pen" aria-hidden="true" />}
                                >
                                    Edit
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        className="detail-action-btn"
                                        onClick={cancelSpecSection}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="primary"
                                        size="sm"
                                        className="detail-action-btn"
                                        onClick={saveSpecSection}
                                    >
                                        Save
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>
                    <div
                        className="Sale-spec-section-nav"
                        role="tablist"
                        aria-label="Specification sections"
                    >
                        {[
                            { id: "doorSystem", label: "Door system", enabled: true },
                            { id: "doorLeft", label: "Door left", enabled: true },
                            {
                                id: "doorMiddle",
                                label: "Middle door",
                                enabled: showMiddleDoorPanel,
                            },
                            { id: "doorRight", label: "Right door", enabled: showRightDoorPanel },
                            { id: "sidelightLeft", label: "Left sidelight", enabled: true },
                            { id: "sidelightRight", label: "Right sidelight", enabled: true },
                            { id: "transom", label: "Transom", enabled: true },
                        ].map((section) => (
                            <button
                                key={section.id}
                                type="button"
                                className={`Sale-spec-nav-btn${
                                    activeSpecPanel === section.id ? " is-active" : ""
                                }`}
                                onClick={() => setActiveSpecPanel(section.id)}
                                disabled={!section.enabled}
                                aria-pressed={activeSpecPanel === section.id}
                            >
                                {section.label}
                            </button>
                        ))}
                    </div>
                    <Collapsible
                        key={`panel-doorSystem-${activeSpecPanel === "doorSystem" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Door System"
                        open={activeSpecPanel === "doorSystem"}
                        onOpening={() => setActiveSpecPanel("doorSystem")}
                    >
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorSystem">Door System</label>
                            <select
                                className="Sale-form-input"
                                id="doorSystem"
                                name="doorSystem"
                                value={updatedSale.productSpecification.doorSystem}
                                onChange={(event) =>
                                    handleUpdate(setUpdatedSale, "doorSystem", event.target.value)
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="Single Door">Single Door</option>
                                <option value="Double Door">Double Door</option>
                                <option value="Triple Door">Triple Door</option>
                            </select>
                        </div>

                        <hr />
                        {inputField(
                            "Brick To Brick",
                            "brickToBrick",
                            updatedSale.productSpecification.brickToBrick,
                            "text",
                            specSectionEditMode,
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Frame Size</h6>
                        {inputField(
                            "Width",
                            "frameSizeWidth",
                            updatedSale.productSpecification.frameSize.width,
                            "number",
                            specSectionEditMode,
                        )}
                        {inputField(
                            "Height",
                            "frameSizeHeight",
                            updatedSale.productSpecification.frameSize.height,
                            "number",
                            specSectionEditMode,
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Jamb</h6>
                        {inputField(
                            "Size",
                            "jambSize",
                            updatedSale.productSpecification.jamb.jambSize,
                            "number",
                            specSectionEditMode,
                            "jamb",
                        )}

                        <div className="Sale-form-input-row">
                            <label htmlFor="jambMaterial">Material</label>
                            <select
                                className="Sale-form-input"
                                id="jambMaterial"
                                name="jambMaterial"
                                value={updatedSale.productSpecification.jamb.jambMaterial}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "jambMaterial",
                                        event.target.value,
                                        "jamb",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Composite Smooth">Composite Smooth</option>
                                <option value="Composite Woodgrain">Composite Woodgrain</option>
                                <option value="Vinyl Wrap">Vinyl Wrap</option>
                                <option value="See Notes">See Notes</option>
                            </select>
                        </div>

                        <hr />
                        <div className="Sale-form-input-row">
                            <label htmlFor="sill">Sill</label>
                            <select
                                className="Sale-form-input"
                                id="sill"
                                name="sill"
                                value={updatedSale.productSpecification.sill}
                                onChange={(event) =>
                                    handleUpdate(setUpdatedSale, "sill", event.target.value)
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {sills.map((sill, index) => (
                                    <option value={sill} key={index}>
                                        {sill}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="sillExtension">Sill Extension</label>
                            <select
                                className="Sale-form-input"
                                id="sillExtension"
                                name="sillExtension"
                                value={updatedSale.productSpecification.sillExtension}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "sillExtension",
                                        event.target.value,
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="1.5">1.5</option>
                                <option value="2.5">2.5</option>
                                <option value="3.5">3.5</option>
                                <option value="4.5">4.5</option>
                            </select>
                        </div>
                    </Collapsible>

                    {/* Left Door */}
                    <Collapsible
                        key={`panel-doorLeft-${activeSpecPanel === "doorLeft" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Door Left"
                        open={activeSpecPanel === "doorLeft"}
                        onOpening={() => setActiveSpecPanel("doorLeft")}
                    >
                        <h6 style={{ fontWeight: "bold" }}>Door</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorMaterial">Material</label>
                            <select
                                className="Sale-form-input"
                                id="doorMaterial"
                                name="doorMaterial"
                                value={updatedSale.productSpecification.doorLeft.doorMaterial}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorMaterial",
                                        event.target.value,
                                        "doorLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="Steel">Steel</option>
                                <option value="Fibreglass">Fibreglass</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Brand</label>
                            <select
                                className="Sale-form-input"
                                id="doorBrand"
                                name="doorBrand"
                                value={updatedSale.productSpecification.doorLeft.doorBrand}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorBrand",
                                        event.target.value,
                                        "doorLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="">Select</option>
                                {updatedSale.productSpecification.doorLeft.doorMaterial ===
                                    "Steel" && <option value="Dusco">Dusco</option>}
                                {updatedSale.productSpecification.doorLeft.doorMaterial ===
                                    "Steel" && <option value="Novatech">Novatech</option>}
                                {updatedSale.productSpecification.doorLeft.doorMaterial ===
                                    "Steel" && <option value="Trutech">Trutech</option>}
                                {updatedSale.productSpecification.doorLeft.doorMaterial ===
                                    "Fibreglass" && <option value="Mennie">Mennie</option>}
                                {updatedSale.productSpecification.doorLeft.doorMaterial ===
                                    "Fibreglass" && <option value="Richersons">Richersons</option>}
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Style</label>
                            <select
                                className="Sale-form-input"
                                id="doorStyle"
                                name="doorStyle"
                                value={updatedSale.productSpecification.doorLeft.doorStyle}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorStyle",
                                        event.target.value,
                                        "doorLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                {updatedSale.productSpecification.doorLeft.doorBrand === "" && (
                                    <option value="">Please Select Door Brand First</option>
                                )}
                                {updatedSale.productSpecification.doorLeft.doorBrand !== "" && (
                                    <option value="">Select</option>
                                )}
                                {DoorStyles.map((doorStyle) => {
                                    if (
                                        updatedSale.productSpecification.doorLeft.doorBrand ===
                                        doorStyle.brand
                                    ) {
                                        return (
                                            <option value={doorStyle.style}>
                                                {doorStyle.style}
                                            </option>
                                        );
                                    }
                                })}
                            </select>
                        </div>

                        {inputField(
                            "Width",
                            "doorSlabWidth",
                            updatedSale.productSpecification.doorLeft.doorSlabWidth,
                            "number",
                            specSectionEditMode,
                            "doorLeft",
                        )}
                        {inputField(
                            "Height",
                            "doorSlabHeight",
                            updatedSale.productSpecification.doorLeft.doorSlabHeight,
                            "number",
                            specSectionEditMode,
                            "doorLeft",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Paint</h6>
                        {inputField(
                            "Out",
                            "paintOut",
                            updatedSale.productSpecification.doorLeft.paintOut,
                            "text",
                            specSectionEditMode,
                            "doorLeft",
                        )}
                        {inputField(
                            "In",
                            "paintIn",
                            updatedSale.productSpecification.doorLeft.paintIn,
                            "text",
                            specSectionEditMode,
                            "doorLeft",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Door Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorInsert">Insert</label>
                            <select
                                className="Sale-form-input"
                                id="doorInsert"
                                name="doorInsert"
                                value={
                                    updatedSale.productSpecification.doorLeft.doorInsert.doorInsert
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorInsert",
                                        event.target.value,
                                        "doorLeftInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="design">Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="design"
                                name="design"
                                value={updatedSale.productSpecification.doorLeft.doorInsert.design}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "design",
                                        event.target.value,
                                        "doorLeftInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Position",
                            "position",
                            updatedSale.productSpecification.doorLeft.doorInsert.position,
                            "text",
                            specSectionEditMode,
                            "doorLeftInsert",
                        )}

                        {inputField(
                            "Quantity",
                            "quantity",
                            updatedSale.productSpecification.doorLeft.doorInsert.quantity,
                            "number",
                            specSectionEditMode,
                            "doorLeftInsert",
                        )}

                        {inputField(
                            "Width",
                            "width",
                            updatedSale.productSpecification.doorLeft.doorInsert.width,
                            "number",
                            specSectionEditMode,
                            "doorLeftInsert",
                        )}
                        {inputField(
                            "Height",
                            "height",
                            updatedSale.productSpecification.doorLeft.doorInsert.height,
                            "number",
                            specSectionEditMode,
                            "doorLeftInsert",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Lock</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="lockType">Type</label>
                            <select
                                className="Sale-form-input"
                                id="lockType"
                                name="lockType"
                                value={updatedSale.productSpecification.doorLeft.lock.lockType}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "lockType",
                                        event.target.value,
                                        "doorLeftLock",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {lockTypes.map((lockType, index) => (
                                    <option key={index} value={lockType}>
                                        {lockType}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {inputField(
                            "Dist. From Top",
                            "distanceFromTop",
                            updatedSale.productSpecification.doorLeft.lock.distanceFromTop,
                            "text",
                            specSectionEditMode,
                            "doorLeftLock",
                        )}

                        {inputField(
                            "Style",
                            "lockStyle",
                            updatedSale.productSpecification.doorLeft.lock.lockStyle,
                            "text",
                            specSectionEditMode,
                            "doorLeftLock",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Hinge</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="hingeColour">Colour</label>
                            <select
                                className="Sale-form-input"
                                id="hingeColour"
                                name="hingeColour"
                                value={updatedSale.productSpecification.doorLeft.hinge.hingeColour}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "hingeColour",
                                        event.target.value,
                                        "doorLeftHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {hingeColours.map((hingeColour, index) => (
                                    <option key={index} value={hingeColour}>
                                        {hingeColour}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="selfClosing">Self Closing</label>
                            <select
                                className="Sale-form-input"
                                id="selfClosing"
                                name="selfClosing"
                                value={updatedSale.productSpecification.doorLeft.hinge.selfClosing}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "selfClosing",
                                        event.target.value,
                                        "doorLeftHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="position">Position</label>
                            <select
                                className="Sale-form-input"
                                id="position"
                                name="position"
                                value={updatedSale.productSpecification.doorLeft.hinge.position}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "position",
                                        event.target.value,
                                        "doorLeftHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                            </select>
                        </div>

                        <hr />

                        <div className="Sale-form-input-row">
                            <label htmlFor="open">Door Open</label>
                            <select
                                className="Sale-form-input"
                                id="open"
                                name="open"
                                value={updatedSale.productSpecification.doorLeft.open}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "open",
                                        event.target.value,
                                        "doorLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                    </Collapsible>

                    {/* Middle Door */}
                    <Collapsible
                        key={`panel-doorMiddle-${activeSpecPanel === "doorMiddle" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Middle Door"
                        open={activeSpecPanel === "doorMiddle" && showMiddleDoorPanel}
                        onOpening={() => setActiveSpecPanel("doorMiddle")}
                    >
                        <h6 style={{ fontWeight: "bold" }}>Door</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorMaterial">Material</label>
                            <select
                                className="Sale-form-input"
                                id="doorMaterial"
                                name="doorMaterial"
                                value={updatedSale.productSpecification.doorMiddle.doorMaterial}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorMaterial",
                                        event.target.value,
                                        "doorMiddle",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="Steel">Steel</option>
                                <option value="Fibreglass">Fibreglass</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Brand</label>
                            <select
                                className="Sale-form-input"
                                id="doorBrand"
                                name="doorBrand"
                                value={updatedSale.productSpecification.doorMiddle.doorBrand}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorBrand",
                                        event.target.value,
                                        "doorMiddle",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="">Select</option>
                                {updatedSale.productSpecification.doorMiddle.doorMaterial ===
                                    "Steel" && <option value="Dusco">Dusco</option>}
                                {updatedSale.productSpecification.doorMiddle.doorMaterial ===
                                    "Steel" && <option value="Novatech">Novatech</option>}
                                {updatedSale.productSpecification.doorMiddle.doorMaterial ===
                                    "Fibreglass" && <option value="Mennie">Mennie</option>}
                                {updatedSale.productSpecification.doorMiddle.doorMaterial ===
                                    "Fibreglass" && <option value="Richersons">Richersons</option>}
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Style</label>
                            <select
                                className="Sale-form-input"
                                id="doorStyle"
                                name="doorStyle"
                                value={updatedSale.productSpecification.doorMiddle.doorStyle}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorStyle",
                                        event.target.value,
                                        "doorMiddle",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                {updatedSale.productSpecification.doorMiddle.doorBrand === "" && (
                                    <option value="">Please Select Door Brand First</option>
                                )}
                                {updatedSale.productSpecification.doorMiddle.doorBrand !== "" && (
                                    <option value="">Select</option>
                                )}
                                {DoorStyles.map((doorStyle) => {
                                    if (
                                        updatedSale.productSpecification.doorMiddle.doorBrand ===
                                        doorStyle.brand
                                    ) {
                                        return (
                                            <option value={doorStyle.style}>
                                                {doorStyle.style}
                                            </option>
                                        );
                                    }
                                })}
                            </select>
                        </div>

                        {inputField(
                            "Width",
                            "doorSlabWidth",
                            updatedSale.productSpecification.doorMiddle.doorSlabWidth,
                            "number",
                            specSectionEditMode,
                            "doorMiddle",
                        )}
                        {inputField(
                            "Height",
                            "doorSlabHeight",
                            updatedSale.productSpecification.doorMiddle.doorSlabHeight,
                            "number",
                            specSectionEditMode,
                            "doorMiddle",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Paint</h6>
                        {inputField(
                            "Out",
                            "paintOut",
                            updatedSale.productSpecification.doorMiddle.paintOut,
                            "text",
                            specSectionEditMode,
                            "doorMiddle",
                        )}
                        {inputField(
                            "In",
                            "paintIn",
                            updatedSale.productSpecification.doorMiddle.paintIn,
                            "text",
                            specSectionEditMode,
                            "doorMiddle",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Door Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorInsert">Insert</label>
                            <select
                                className="Sale-form-input"
                                id="doorInsert"
                                name="doorInsert"
                                value={
                                    updatedSale.productSpecification.doorMiddle.doorInsert
                                        .doorInsert
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorInsert",
                                        event.target.value,
                                        "doorMiddleInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="design">Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="design"
                                name="design"
                                value={
                                    updatedSale.productSpecification.doorMiddle.doorInsert.design
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "design",
                                        event.target.value,
                                        "doorMiddleInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Position",
                            "position",
                            updatedSale.productSpecification.doorMiddle.doorInsert.position,
                            "text",
                            specSectionEditMode,
                            "doorMiddleInsert",
                        )}

                        {inputField(
                            "Quantity",
                            "quantity",
                            updatedSale.productSpecification.doorMiddle.doorInsert.quantity,
                            "number",
                            specSectionEditMode,
                            "doorMiddleInsert",
                        )}

                        {inputField(
                            "Width",
                            "width",
                            updatedSale.productSpecification.doorMiddle.doorInsert.width,
                            "number",
                            specSectionEditMode,
                            "doorMiddleInsert",
                        )}
                        {inputField(
                            "Height",
                            "height",
                            updatedSale.productSpecification.doorMiddle.doorInsert.height,
                            "number",
                            specSectionEditMode,
                            "doorMiddleInsert",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Lock</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="lockType">Type</label>
                            <select
                                className="Sale-form-input"
                                id="lockType"
                                name="lockType"
                                value={updatedSale.productSpecification.doorMiddle.lock.lockType}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "lockType",
                                        event.target.value,
                                        "doorMiddleLock",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {lockTypes.map((lockType, index) => (
                                    <option key={index} value={lockType}>
                                        {lockType}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {inputField(
                            "Dist. From Top",
                            "distanceFromTop",
                            updatedSale.productSpecification.doorMiddle.lock.distanceFromTop,
                            "text",
                            specSectionEditMode,
                            "doorMiddleLock",
                        )}

                        {inputField(
                            "Style",
                            "lockStyle",
                            updatedSale.productSpecification.doorMiddle.lock.lockStyle,
                            "text",
                            specSectionEditMode,
                            "doorMiddleLock",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Hinge</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="hingeColour">Colour</label>
                            <select
                                className="Sale-form-input"
                                id="hingeColour"
                                name="hingeColour"
                                value={
                                    updatedSale.productSpecification.doorMiddle.hinge.hingeColour
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "hingeColour",
                                        event.target.value,
                                        "doorMiddleHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {hingeColours.map((hingeColour, index) => (
                                    <option key={index} value={hingeColour}>
                                        {hingeColour}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="selfClosing">Self Closing</label>
                            <select
                                className="Sale-form-input"
                                id="selfClosing"
                                name="selfClosing"
                                value={
                                    updatedSale.productSpecification.doorMiddle.hinge.selfClosing
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "selfClosing",
                                        event.target.value,
                                        "doorMiddleHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="position">Position</label>
                            <select
                                className="Sale-form-input"
                                id="position"
                                name="position"
                                value={updatedSale.productSpecification.doorMiddle.hinge.position}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "position",
                                        event.target.value,
                                        "doorMiddleHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                            </select>
                        </div>

                        <hr />

                        <div className="Sale-form-input-row">
                            <label htmlFor="open">Door Open</label>
                            <select
                                className="Sale-form-input"
                                id="open"
                                name="open"
                                value={updatedSale.productSpecification.doorMiddle.open}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "open",
                                        event.target.value,
                                        "doorMiddle",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                    </Collapsible>

                    {/* Right Door */}
                    <Collapsible
                        key={`panel-doorRight-${activeSpecPanel === "doorRight" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Right Door"
                        open={activeSpecPanel === "doorRight" && showRightDoorPanel}
                        onOpening={() => setActiveSpecPanel("doorRight")}
                    >
                        <h6 style={{ fontWeight: "bold" }}>Door</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorMaterial">Material</label>
                            <select
                                className="Sale-form-input"
                                id="doorMaterial"
                                name="doorMaterial"
                                value={updatedSale.productSpecification.doorRight.doorMaterial}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorMaterial",
                                        event.target.value,
                                        "doorRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="Steel">Steel</option>
                                <option value="Fibreglass">Fibreglass</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Brand</label>
                            <select
                                className="Sale-form-input"
                                id="doorBrand"
                                name="doorBrand"
                                value={updatedSale.productSpecification.doorRight.doorBrand}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorBrand",
                                        event.target.value,
                                        "doorRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="">Select</option>
                                {updatedSale.productSpecification.doorRight.doorMaterial ===
                                    "Steel" && <option value="Dusco">Dusco</option>}
                                {updatedSale.productSpecification.doorRight.doorMaterial ===
                                    "Steel" && <option value="Novatech">Novatech</option>}
                                {updatedSale.productSpecification.doorRight.doorMaterial ===
                                    "Fibreglass" && <option value="Mennie">Mennie</option>}
                                {updatedSale.productSpecification.doorRight.doorMaterial ===
                                    "Fibreglass" && <option value="Richersons">Richersons</option>}
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="doorBrand">Style</label>
                            <select
                                className="Sale-form-input"
                                id="doorStyle"
                                name="doorStyle"
                                value={updatedSale.productSpecification.doorRight.doorStyle}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorStyle",
                                        event.target.value,
                                        "doorRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                {updatedSale.productSpecification.doorRight.doorBrand === "" && (
                                    <option value="">Please Select Door Brand First</option>
                                )}
                                {updatedSale.productSpecification.doorRight.doorBrand !== "" && (
                                    <option value="">Select</option>
                                )}
                                {DoorStyles.map((doorStyle) => {
                                    if (
                                        updatedSale.productSpecification.doorRight.doorBrand ===
                                        doorStyle.brand
                                    ) {
                                        return (
                                            <option value={doorStyle.style}>
                                                {doorStyle.style}
                                            </option>
                                        );
                                    }
                                })}
                            </select>
                        </div>

                        {inputField(
                            "Width",
                            "doorSlabWidth",
                            updatedSale.productSpecification.doorRight.doorSlabWidth,
                            "number",
                            specSectionEditMode,
                            "doorRight",
                        )}
                        {inputField(
                            "Height",
                            "doorSlabHeight",
                            updatedSale.productSpecification.doorRight.doorSlabHeight,
                            "number",
                            specSectionEditMode,
                            "doorRight",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Paint</h6>
                        {inputField(
                            "Out",
                            "paintOut",
                            updatedSale.productSpecification.doorRight.paintOut,
                            "text",
                            specSectionEditMode,
                            "doorRight",
                        )}
                        {inputField(
                            "In",
                            "paintIn",
                            updatedSale.productSpecification.doorRight.paintIn,
                            "text",
                            specSectionEditMode,
                            "doorRight",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Door Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="doorInsert">Insert</label>
                            <select
                                className="Sale-form-input"
                                id="doorInsert"
                                name="doorInsert"
                                value={
                                    updatedSale.productSpecification.doorRight.doorInsert.doorInsert
                                }
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "doorInsert",
                                        event.target.value,
                                        "doorRightInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="design">Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="design"
                                name="design"
                                value={updatedSale.productSpecification.doorRight.doorInsert.design}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "design",
                                        event.target.value,
                                        "doorRightInsert",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Position",
                            "position",
                            updatedSale.productSpecification.doorRight.doorInsert.position,
                            "text",
                            specSectionEditMode,
                            "doorRightInsert",
                        )}

                        {inputField(
                            "Quantity",
                            "quantity",
                            updatedSale.productSpecification.doorRight.doorInsert.quantity,
                            "number",
                            specSectionEditMode,
                            "doorRightInsert",
                        )}

                        {inputField(
                            "Width",
                            "width",
                            updatedSale.productSpecification.doorRight.doorInsert.width,
                            "number",
                            specSectionEditMode,
                            "doorRightInsert",
                        )}
                        {inputField(
                            "Height",
                            "height",
                            updatedSale.productSpecification.doorRight.doorInsert.height,
                            "number",
                            specSectionEditMode,
                            "doorRightInsert",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Lock</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="lockType">Type</label>
                            <select
                                className="Sale-form-input"
                                id="lockType"
                                name="lockType"
                                value={updatedSale.productSpecification.doorRight.lock.lockType}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "lockType",
                                        event.target.value,
                                        "doorRightLock",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {lockTypes.map((lockType, index) => (
                                    <option key={index} value={lockType}>
                                        {lockType}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {inputField(
                            "Dist. From Top",
                            "distanceFromTop",
                            updatedSale.productSpecification.doorRight.lock.distanceFromTop,
                            "text",
                            specSectionEditMode,
                            "doorRightLock",
                        )}

                        {inputField(
                            "Style",
                            "lockStyle",
                            updatedSale.productSpecification.doorRight.lock.lockStyle,
                            "text",
                            specSectionEditMode,
                            "doorRightLock",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Hinge</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="hingeColour">Colour</label>
                            <select
                                className="Sale-form-input"
                                id="hingeColour"
                                name="hingeColour"
                                value={updatedSale.productSpecification.doorRight.hinge.hingeColour}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "hingeColour",
                                        event.target.value,
                                        "doorRightHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                {hingeColours.map((hingeColour, index) => (
                                    <option key={index} value={hingeColour}>
                                        {hingeColour}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="selfClosing">Self Closing</label>
                            <select
                                className="Sale-form-input"
                                id="selfClosing"
                                name="selfClosing"
                                value={updatedSale.productSpecification.doorRight.hinge.selfClosing}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "selfClosing",
                                        event.target.value,
                                        "doorRightHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="position">Position</label>
                            <select
                                className="Sale-form-input"
                                id="position"
                                name="position"
                                value={updatedSale.productSpecification.doorRight.hinge.position}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "position",
                                        event.target.value,
                                        "doorRightHinge",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                            </select>
                        </div>

                        <hr />
                        <div className="Sale-form-input-row">
                            <label htmlFor="open">Door Open</label>
                            <select
                                className="Sale-form-input"
                                id="open"
                                name="open"
                                value={updatedSale.productSpecification.doorRight.open}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "open",
                                        event.target.value,
                                        "doorRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                    </Collapsible>

                    {/* SIDELIGHT LEFT */}
                    <Collapsible
                        key={`panel-sidelightLeft-${activeSpecPanel === "sidelightLeft" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Left Sidelight"
                        open={activeSpecPanel === "sidelightLeft"}
                        onOpening={() => setActiveSpecPanel("sidelightLeft")}
                    >
                        <div className="Sale-form-input-row">
                            <label htmlFor="sidelightBox">Side Light</label>
                            <select
                                className="Sale-form-input"
                                id="sidelight"
                                name="sidelight"
                                value={updatedSale.productSpecification.sidelightLeft.sidelight}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "sidelight",
                                        event.target.value,
                                        "sidelightLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        {inputField(
                            "# Of Panels",
                            "panel",
                            updatedSale.productSpecification.sidelightLeft.panel,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}

                        {inputField(
                            "Panel 1 Width",
                            "panelWidth",
                            updatedSale.productSpecification.sidelightLeft.panelWidth,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}

                        {inputField(
                            "Panel 1 Height",
                            "panelHeight",
                            updatedSale.productSpecification.sidelightLeft.panelHeight,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}

                        {inputField(
                            "Panel 2 Width",
                            "panelWidth2",
                            updatedSale.productSpecification.sidelightLeft.panelWidth2,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}

                        {inputField(
                            "Panel 2 Height",
                            "panelHeight2",
                            updatedSale.productSpecification.sidelightLeft.panelHeight2,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="sidelightLeftInsert">Glass Insert</label>
                            <select
                                className="Sale-form-input"
                                id="sidelightLeftInsert"
                                name="insert"
                                value={updatedSale.productSpecification.sidelightLeft.insert}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "insert",
                                        event.target.value,
                                        "sidelightLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="insertDesign">Insert Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="insertDesign"
                                name="insertDesign"
                                value={updatedSale.productSpecification.sidelightLeft.insertDesign}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "insertDesign",
                                        event.target.value,
                                        "sidelightLeft",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Width",
                            "insertWidth",
                            updatedSale.productSpecification.sidelightLeft.insertWidth,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}
                        {inputField(
                            "Height",
                            "insertHeight",
                            updatedSale.productSpecification.sidelightLeft.insertHeight,
                            "number",
                            specSectionEditMode,
                            "sidelightLeft",
                        )}
                    </Collapsible>

                    {/* SIDELIGHT Right */}
                    <Collapsible
                        key={`panel-sidelightRight-${activeSpecPanel === "sidelightRight" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Right Sidelight"
                        open={activeSpecPanel === "sidelightRight"}
                        onOpening={() => setActiveSpecPanel("sidelightRight")}
                    >
                        <div className="Sale-form-input-row">
                            <label htmlFor="sidelightBox">Side Light</label>
                            <select
                                className="Sale-form-input"
                                id="sidelight"
                                name="sidelight"
                                value={updatedSale.productSpecification.sidelightRight.sidelight}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "sidelight",
                                        event.target.value,
                                        "sidelightRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        {inputField(
                            "# Of Panels",
                            "panel",
                            updatedSale.productSpecification.sidelightRight.panel,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}

                        {inputField(
                            "Panel 1 Width",
                            "panelWidth",
                            updatedSale.productSpecification.sidelightRight.panelWidth,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}

                        {inputField(
                            "Panel 1 Height",
                            "panelHeight",
                            updatedSale.productSpecification.sidelightRight.panelHeight,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}

                        {inputField(
                            "Panel 2 Width",
                            "panelWidth2",
                            updatedSale.productSpecification.sidelightRight.panelWidth2,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}

                        {inputField(
                            "Panel 2 Height",
                            "panelHeight2",
                            updatedSale.productSpecification.sidelightRight.panelHeight2,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="sidelightRightInsert">Glass Insert</label>
                            <select
                                className="Sale-form-input"
                                id="sidelightRightInsert"
                                name="insert"
                                value={updatedSale.productSpecification.sidelightRight.insert}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "insert",
                                        event.target.value,
                                        "sidelightRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="insertDesign">Insert Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="insertDesign"
                                name="insertDesign"
                                value={updatedSale.productSpecification.sidelightRight.insertDesign}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "insertDesign",
                                        event.target.value,
                                        "sidelightRight",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Width",
                            "insertWidth",
                            updatedSale.productSpecification.sidelightRight.insertWidth,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}
                        {inputField(
                            "Height",
                            "insertHeight",
                            updatedSale.productSpecification.sidelightRight.insertHeight,
                            "number",
                            specSectionEditMode,
                            "sidelightRight",
                        )}
                    </Collapsible>

                    {/* TRANSOM */}
                    <Collapsible
                        key={`panel-transom-${activeSpecPanel === "transom" ? "open" : "closed"}`}
                        className="collapsible-section"
                        trigger="Transom"
                        open={activeSpecPanel === "transom"}
                        onOpening={() => setActiveSpecPanel("transom")}
                    >
                        <div className="Sale-form-input-row">
                            <label htmlFor="transomBox">Transom</label>
                            <select
                                className="Sale-form-input"
                                id="transomBox"
                                name="transomBox"
                                value={updatedSale.productSpecification.transom.transomBox}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "transomBox",
                                        event.target.value,
                                        "transom",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                        <div className="Sale-form-input-row">
                            <label htmlFor="transomType">Type</label>
                            <select
                                className="Sale-form-input"
                                id="transomType"
                                name="transomType"
                                value={updatedSale.productSpecification.transom.transomType}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "transomType",
                                        event.target.value,
                                        "transom",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            >
                                <option value=""></option>
                                <option value="Regular">Regular</option>
                                <option value="Arc">Arc</option>
                            </select>
                        </div>

                        {inputField(
                            "Arc Height",
                            "transomArcHeight",
                            updatedSale.productSpecification.transom.transomArcHeight,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}

                        {inputField(
                            "Arc Legs",
                            "transomArcLegs",
                            updatedSale.productSpecification.transom.transomArcLegs,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}

                        {inputField(
                            "Transom Rows",
                            "transomRow",
                            updatedSale.productSpecification.transom.transomRow,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}

                        {inputField(
                            "Transom Columns",
                            "transomColumn",
                            updatedSale.productSpecification.transom.transomColumn,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}

                        <hr />
                        <h6 style={{ fontWeight: "bold" }}>Insert</h6>
                        <div className="Sale-form-input-row">
                            <label htmlFor="transomInsertDesign">Insert Design</label>
                            <input
                                className="Sale-form-input"
                                type="text"
                                list="insertDesigns"
                                id="transomInsertDesigns"
                                name="transomInsertDesign"
                                value={updatedSale.productSpecification.transom.transomInsertDesign}
                                onChange={(event) =>
                                    handleUpdate(
                                        setUpdatedSale,
                                        "transomInsertDesign",
                                        event.target.value,
                                        "transom",
                                    )
                                }
                                onBlur={setRecentActivities}
                                disabled={!specSectionEditMode}
                            />
                            <datalist id="insertDesigns">
                                {InsertDesigns.map((insertDesign) => {
                                    return <option value={`${insertDesign.design}`} />;
                                })}
                            </datalist>
                        </div>

                        {inputField(
                            "Width",
                            "transomInsertWidth",
                            updatedSale.productSpecification.transom.transomInsertWidth,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}
                        {inputField(
                            "Height",
                            "transomInsertHeight",
                            updatedSale.productSpecification.transom.transomInsertHeight,
                            "number",
                            specSectionEditMode,
                            "transom",
                        )}
                    </Collapsible>
                </form>
            </SaleProductSpecificationsSection>
        </div>
    );
};

export default Sale;
